var map = {
	"./ANIMALS/ant.png": 17408,
	"./ANIMALS/anteater.png": 24210,
	"./ANIMALS/bear.png": 47988,
	"./ANIMALS/bee.png": 48858,
	"./ANIMALS/beetle.png": 60700,
	"./ANIMALS/bison.png": 76795,
	"./ANIMALS/camel.png": 69027,
	"./ANIMALS/cat.png": 34676,
	"./ANIMALS/chameleon.png": 42870,
	"./ANIMALS/cheetah.png": 89697,
	"./ANIMALS/chicken.png": 73720,
	"./ANIMALS/clown_fish.png": 93204,
	"./ANIMALS/cougar.png": 5131,
	"./ANIMALS/cow.png": 5954,
	"./ANIMALS/crab.png": 28753,
	"./ANIMALS/crocodile.png": 55924,
	"./ANIMALS/deer.png": 80458,
	"./ANIMALS/dog.png": 14470,
	"./ANIMALS/dolphin.png": 14781,
	"./ANIMALS/duck.png": 46402,
	"./ANIMALS/eagle.png": 84023,
	"./ANIMALS/elephant.png": 72109,
	"./ANIMALS/flamingo.png": 20202,
	"./ANIMALS/fox.png": 89402,
	"./ANIMALS/frog.png": 12593,
	"./ANIMALS/giraffe.png": 8873,
	"./ANIMALS/goat.png": 28765,
	"./ANIMALS/gorilla.png": 79518,
	"./ANIMALS/hamster.png": 27659,
	"./ANIMALS/hedgehog.png": 86553,
	"./ANIMALS/hippopotamus.png": 92213,
	"./ANIMALS/horse.png": 8539,
	"./ANIMALS/hummingbird.png": 73140,
	"./ANIMALS/jellyfish.png": 95537,
	"./ANIMALS/kangaroo.png": 14736,
	"./ANIMALS/kiwi.png": 72437,
	"./ANIMALS/koala.png": 7287,
	"./ANIMALS/ladybug.png": 73210,
	"./ANIMALS/lemur.png": 10362,
	"./ANIMALS/leopard.png": 72927,
	"./ANIMALS/lion.png": 80286,
	"./ANIMALS/llama.png": 68903,
	"./ANIMALS/lobster.png": 34640,
	"./ANIMALS/manta_ray.png": 45655,
	"./ANIMALS/monkey.png": 61090,
	"./ANIMALS/octopus.png": 23365,
	"./ANIMALS/orangutan.png": 62312,
	"./ANIMALS/orca.png": 59668,
	"./ANIMALS/ostrich.png": 16115,
	"./ANIMALS/otter.png": 6875,
	"./ANIMALS/owl.png": 31237,
	"./ANIMALS/panda.png": 77250,
	"./ANIMALS/panther.png": 91668,
	"./ANIMALS/peacock.png": 29467,
	"./ANIMALS/penguin.png": 37212,
	"./ANIMALS/pig.png": 58745,
	"./ANIMALS/pigeon.png": 10505,
	"./ANIMALS/platypus.png": 29062,
	"./ANIMALS/polar_bear.png": 4080,
	"./ANIMALS/prawn.png": 70095,
	"./ANIMALS/praying_mantis.png": 24529,
	"./ANIMALS/puffer_fish.png": 30027,
	"./ANIMALS/rabbit.png": 85165,
	"./ANIMALS/raccoon.png": 28434,
	"./ANIMALS/rat.png": 75892,
	"./ANIMALS/reindeer.png": 54689,
	"./ANIMALS/rhinoceros.png": 11066,
	"./ANIMALS/salmon.png": 74145,
	"./ANIMALS/scorpion.png": 10353,
	"./ANIMALS/seahorse.png": 9866,
	"./ANIMALS/seal.png": 15803,
	"./ANIMALS/shark.png": 87324,
	"./ANIMALS/sheep.png": 30570,
	"./ANIMALS/skunk.png": 9162,
	"./ANIMALS/sloth.png": 99782,
	"./ANIMALS/snail.png": 44631,
	"./ANIMALS/snake.png": 91454,
	"./ANIMALS/spider.png": 20737,
	"./ANIMALS/squirrel.png": 15223,
	"./ANIMALS/starfish.png": 56063,
	"./ANIMALS/swan.png": 81199,
	"./ANIMALS/tiger.png": 93603,
	"./ANIMALS/toucan.png": 17781,
	"./ANIMALS/turkey.png": 86662,
	"./ANIMALS/turtle.png": 57567,
	"./ANIMALS/walrus.png": 67074,
	"./ANIMALS/whale.png": 23945,
	"./ANIMALS/wolf.png": 81794,
	"./ANIMALS/yak.png": 37814,
	"./ANIMALS/zebra.png": 82579,
	"./ANIME/Alphonse_Elric.png": 73089,
	"./ANIME/Arale.png": 83821,
	"./ANIME/Armin.png": 26192,
	"./ANIME/Armored_Titan.png": 6345,
	"./ANIME/Ash_Ketchum.png": 11143,
	"./ANIME/Benji.png": 35037,
	"./ANIME/Bulma.png": 85942,
	"./ANIME/Cell.png": 52888,
	"./ANIME/Chihiro_Ogiro.png": 38985,
	"./ANIME/Chopper.png": 53806,
	"./ANIME/Colossal_Titan.png": 42896,
	"./ANIME/Detective_Conan.png": 72150,
	"./ANIME/Devil_man.png": 67610,
	"./ANIME/Dio_Brando.png": 84859,
	"./ANIME/Doraemon.png": 8322,
	"./ANIME/Edward_Elric.png": 9594,
	"./ANIME/Eikichi_Onizuka.png": 31755,
	"./ANIME/Eren.png": 27761,
	"./ANIME/Freezer.png": 30055,
	"./ANIME/Fukijo_Mine.png": 22962,
	"./ANIME/Genos.png": 59550,
	"./ANIME/Giorno_Giovanna.png": 78906,
	"./ANIME/Goemon.png": 71780,
	"./ANIME/Gohan_Kid.png": 93879,
	"./ANIME/Goku.png": 83836,
	"./ANIME/Gon_Freecss.png": 75083,
	"./ANIME/Goro.png": 96090,
	"./ANIME/Gundam.png": 94558,
	"./ANIME/Hanamichi_Sakuragi.png": 76044,
	"./ANIME/Haru.png": 33081,
	"./ANIME/Holly.png": 25665,
	"./ANIME/Ichigo_Kurosaki.png": 7721,
	"./ANIME/Inuyasha.png": 91610,
	"./ANIME/Jaden_Yuki.png": 3687,
	"./ANIME/Jigen.png": 75845,
	"./ANIME/Jotaro_Kujo.png": 62427,
	"./ANIME/Junior.png": 9655,
	"./ANIME/Kakashi.png": 17683,
	"./ANIME/Kaneki_Ken.png": 85556,
	"./ANIME/Kenshiro.png": 21796,
	"./ANIME/Kenzou_Tenma.png": 2561,
	"./ANIME/Koichi_Zenigata.png": 87196,
	"./ANIME/Koro_Sensei.png": 52405,
	"./ANIME/Krillin.png": 38666,
	"./ANIME/Kurapika.png": 24401,
	"./ANIME/Kurisu_Makise.png": 5826,
	"./ANIME/L.png": 37406,
	"./ANIME/Legoshi.png": 63437,
	"./ANIME/Lelouch_VI.png": 46145,
	"./ANIME/Leorio_Paladiknight.png": 53607,
	"./ANIME/Levi.png": 95644,
	"./ANIME/Light_Yagami.png": 56333,
	"./ANIME/Lum.png": 12824,
	"./ANIME/Lupin_lll.png": 82824,
	"./ANIME/Majin_Bu.png": 81338,
	"./ANIME/Mark_Lenders.png": 11656,
	"./ANIME/Midoriya.png": 83745,
	"./ANIME/Mikasa.png": 33925,
	"./ANIME/Mila.png": 73899,
	"./ANIME/Misa_Amane.png": 61435,
	"./ANIME/Mokoko_Sakura.png": 14015,
	"./ANIME/Monkey_D_Luffy.png": 68037,
	"./ANIME/Nami.png": 5177,
	"./ANIME/Naruto.png": 1089,
	"./ANIME/Natsu_Dragneel.png": 74404,
	"./ANIME/Nezuko.png": 46620,
	"./ANIME/No-Face.png": 98486,
	"./ANIME/Nobita.png": 16202,
	"./ANIME/Okabe_Rintarou.png": 90381,
	"./ANIME/Orochimaru.png": 98897,
	"./ANIME/Pegaso.png": 3384,
	"./ANIME/Rocky_Joe.png": 78362,
	"./ANIME/Roshi.png": 9483,
	"./ANIME/Roy_Mustang.png": 13785,
	"./ANIME/Ryuk.png": 460,
	"./ANIME/Sailor_Moon.png": 28519,
	"./ANIME/Saitama.png": 71185,
	"./ANIME/Sakata_Gintoki.png": 44720,
	"./ANIME/Sakura.png": 70596,
	"./ANIME/Sanji.png": 58463,
	"./ANIME/Sasuke.png": 36275,
	"./ANIME/Senku_Ishigami.png": 40480,
	"./ANIME/Seto_Kaiba.png": 98262,
	"./ANIME/Shiina_Mayuri.png": 61512,
	"./ANIME/Shin_Chan.png": 97217,
	"./ANIME/Shinji.png": 60593,
	"./ANIME/Shiro_Takiki.png": 69782,
	"./ANIME/Tanjiro.png": 63444,
	"./ANIME/Tuxedo_Mask.png": 21894,
	"./ANIME/Usop.png": 31993,
	"./ANIME/Vegeta.png": 80217,
	"./ANIME/Yami_Yugi.png": 99883,
	"./ANIME/Yoh_Asakura.png": 54608,
	"./ANIME/Yubaba.png": 75955,
	"./ANIME/Zoro_Roronoa.png": 83358,
	"./COUNTRIES/albania.png": 6314,
	"./COUNTRIES/algeria.png": 76583,
	"./COUNTRIES/andorra.png": 98470,
	"./COUNTRIES/antigua-and-barbuda.png": 43516,
	"./COUNTRIES/argentina.png": 6188,
	"./COUNTRIES/australia.png": 83150,
	"./COUNTRIES/austria.png": 23545,
	"./COUNTRIES/azerbaijan.png": 59700,
	"./COUNTRIES/bahamas.png": 95399,
	"./COUNTRIES/bangladesh.png": 69060,
	"./COUNTRIES/barbados.png": 80500,
	"./COUNTRIES/belgium.png": 44753,
	"./COUNTRIES/belize.png": 43844,
	"./COUNTRIES/bolivia.png": 49189,
	"./COUNTRIES/bosnia-and-herzegovina.png": 62648,
	"./COUNTRIES/brazil.png": 33554,
	"./COUNTRIES/bulgaria.png": 66857,
	"./COUNTRIES/canada.png": 52156,
	"./COUNTRIES/chile.png": 35924,
	"./COUNTRIES/china.png": 18721,
	"./COUNTRIES/colombia.png": 17961,
	"./COUNTRIES/costa-rica.png": 49001,
	"./COUNTRIES/croatia.png": 32577,
	"./COUNTRIES/cuba.png": 88335,
	"./COUNTRIES/cyprus.png": 40267,
	"./COUNTRIES/czech-republic.png": 54306,
	"./COUNTRIES/denmark.png": 95407,
	"./COUNTRIES/dominica.png": 53548,
	"./COUNTRIES/dominican-republic.png": 64116,
	"./COUNTRIES/ecuador.png": 39268,
	"./COUNTRIES/egypt.png": 40891,
	"./COUNTRIES/el-salvador.png": 41652,
	"./COUNTRIES/england.png": 38749,
	"./COUNTRIES/estonia.png": 22804,
	"./COUNTRIES/finland.png": 3353,
	"./COUNTRIES/france.png": 88219,
	"./COUNTRIES/germany.png": 83379,
	"./COUNTRIES/ghana.png": 32658,
	"./COUNTRIES/greece.png": 20721,
	"./COUNTRIES/grenada.png": 61581,
	"./COUNTRIES/guatemala.png": 75252,
	"./COUNTRIES/guyana.png": 89181,
	"./COUNTRIES/haiti.png": 65489,
	"./COUNTRIES/honduras.png": 36377,
	"./COUNTRIES/hungary.png": 68032,
	"./COUNTRIES/iceland.png": 21351,
	"./COUNTRIES/india.png": 39533,
	"./COUNTRIES/indonesia.png": 32496,
	"./COUNTRIES/iran.png": 2734,
	"./COUNTRIES/iraq.png": 73934,
	"./COUNTRIES/ireland.png": 39306,
	"./COUNTRIES/israel.png": 18769,
	"./COUNTRIES/italy.png": 15665,
	"./COUNTRIES/jamaica.png": 58052,
	"./COUNTRIES/japan.png": 76233,
	"./COUNTRIES/kazakhstan.png": 48860,
	"./COUNTRIES/kosovo.png": 91486,
	"./COUNTRIES/liechtenstein.png": 69615,
	"./COUNTRIES/lithuania.png": 36554,
	"./COUNTRIES/luxembourg.png": 80759,
	"./COUNTRIES/malta.png": 53418,
	"./COUNTRIES/mexico.png": 99974,
	"./COUNTRIES/moldova.png": 60618,
	"./COUNTRIES/monaco.png": 54410,
	"./COUNTRIES/mongolia.png": 32489,
	"./COUNTRIES/montenegro.png": 42804,
	"./COUNTRIES/morocco.png": 81900,
	"./COUNTRIES/nepal.png": 38943,
	"./COUNTRIES/netherlands.png": 90543,
	"./COUNTRIES/new-zealand.png": 57213,
	"./COUNTRIES/nicaragua.png": 11988,
	"./COUNTRIES/north-korea.png": 46706,
	"./COUNTRIES/norway.png": 75334,
	"./COUNTRIES/pakistan.png": 91795,
	"./COUNTRIES/panama.png": 49716,
	"./COUNTRIES/paraguay.png": 13757,
	"./COUNTRIES/peru.png": 1566,
	"./COUNTRIES/philippines.png": 74828,
	"./COUNTRIES/portugal.png": 69144,
	"./COUNTRIES/qatar.png": 91545,
	"./COUNTRIES/republic-of-macedonia.png": 30843,
	"./COUNTRIES/republic-of-poland.png": 86730,
	"./COUNTRIES/republic-of-the-congo.png": 32384,
	"./COUNTRIES/romania.png": 72806,
	"./COUNTRIES/russia.png": 28497,
	"./COUNTRIES/saint-kitts-and-nevis.png": 74266,
	"./COUNTRIES/san-marino.png": 15558,
	"./COUNTRIES/saudi-arabia.png": 84491,
	"./COUNTRIES/scotland.png": 93216,
	"./COUNTRIES/senegal.png": 80081,
	"./COUNTRIES/serbia.png": 94939,
	"./COUNTRIES/slovakia.png": 49492,
	"./COUNTRIES/slovenia.png": 43173,
	"./COUNTRIES/south-africa.png": 44552,
	"./COUNTRIES/south-korea.png": 51915,
	"./COUNTRIES/spain.png": 23946,
	"./COUNTRIES/st-lucia.png": 54629,
	"./COUNTRIES/st-vincent-and-the-grenadines.png": 11952,
	"./COUNTRIES/sudan.png": 52505,
	"./COUNTRIES/suriname.png": 1848,
	"./COUNTRIES/sweden.png": 71668,
	"./COUNTRIES/switzerland.png": 66588,
	"./COUNTRIES/thailand.png": 3662,
	"./COUNTRIES/trinidad-and-tobago.png": 19986,
	"./COUNTRIES/tunisia.png": 6302,
	"./COUNTRIES/turkey.png": 78908,
	"./COUNTRIES/ukraine.png": 3588,
	"./COUNTRIES/united-states-of-america.png": 67709,
	"./COUNTRIES/uruguay.png": 45316,
	"./COUNTRIES/vatican-city.png": 1498,
	"./COUNTRIES/venezuela.png": 49765,
	"./COUNTRIES/vietnam.png": 54438,
	"./COUNTRIES/wales.png": 92090,
	"./DRAGONBALL/android_16.png": 93797,
	"./DRAGONBALL/android_17.png": 39993,
	"./DRAGONBALL/android_18.png": 30136,
	"./DRAGONBALL/android_19.png": 20887,
	"./DRAGONBALL/android_20_dr_gero.png": 47630,
	"./DRAGONBALL/baba.png": 37626,
	"./DRAGONBALL/babidi.png": 82848,
	"./DRAGONBALL/baby.png": 78725,
	"./DRAGONBALL/bardock.png": 59160,
	"./DRAGONBALL/beerus.png": 60826,
	"./DRAGONBALL/broly.png": 75613,
	"./DRAGONBALL/bulma.png": 8234,
	"./DRAGONBALL/burter.png": 30634,
	"./DRAGONBALL/cell.png": 28997,
	"./DRAGONBALL/chi_chi.png": 9274,
	"./DRAGONBALL/chiaotzu.png": 93440,
	"./DRAGONBALL/cooler.png": 14211,
	"./DRAGONBALL/dabura.png": 38306,
	"./DRAGONBALL/dende.png": 8779,
	"./DRAGONBALL/dodoria.png": 2029,
	"./DRAGONBALL/frieza.png": 58799,
	"./DRAGONBALL/future_trunks.png": 72909,
	"./DRAGONBALL/garlic_jr.png": 42011,
	"./DRAGONBALL/general_red_red_ribbon.png": 35007,
	"./DRAGONBALL/ginyu.png": 87284,
	"./DRAGONBALL/gogeta_ssj4.png": 88734,
	"./DRAGONBALL/gohan_kid_freezer_saga.png": 75805,
	"./DRAGONBALL/gohan_ssj.png": 84038,
	"./DRAGONBALL/goku_black.png": 16292,
	"./DRAGONBALL/goku_normal.png": 89548,
	"./DRAGONBALL/goku_ssj.png": 71761,
	"./DRAGONBALL/goku_ssj3.png": 31112,
	"./DRAGONBALL/goku_ssj4.png": 49469,
	"./DRAGONBALL/goku_ssj_blue.png": 77883,
	"./DRAGONBALL/goku_ultra_instinct.png": 6834,
	"./DRAGONBALL/golden_frieza.png": 34196,
	"./DRAGONBALL/goten.png": 88511,
	"./DRAGONBALL/gotenks.png": 72763,
	"./DRAGONBALL/gotenks_ssj3.png": 58506,
	"./DRAGONBALL/grandpa_gohan.png": 94966,
	"./DRAGONBALL/great_ape.png": 36831,
	"./DRAGONBALL/guldo.png": 34969,
	"./DRAGONBALL/hit.png": 20120,
	"./DRAGONBALL/janemba.png": 18595,
	"./DRAGONBALL/jeice.png": 42610,
	"./DRAGONBALL/jiren.png": 2221,
	"./DRAGONBALL/kaioshin.png": 68059,
	"./DRAGONBALL/kami.png": 55727,
	"./DRAGONBALL/karin.png": 8397,
	"./DRAGONBALL/kid_buu.png": 24535,
	"./DRAGONBALL/king_cold.png": 25724,
	"./DRAGONBALL/king_kai.png": 78954,
	"./DRAGONBALL/king_piccolo.png": 441,
	"./DRAGONBALL/krillin.png": 31178,
	"./DRAGONBALL/launch.png": 70574,
	"./DRAGONBALL/majin_buu.png": 70086,
	"./DRAGONBALL/majin_vegeta.png": 60464,
	"./DRAGONBALL/master_roshi.png": 68028,
	"./DRAGONBALL/mr_popo.png": 63473,
	"./DRAGONBALL/mr_satan.png": 72778,
	"./DRAGONBALL/nappa.png": 37869,
	"./DRAGONBALL/omega_shenron.png": 78385,
	"./DRAGONBALL/oolong.png": 948,
	"./DRAGONBALL/pan.png": 97345,
	"./DRAGONBALL/piccolo.png": 52637,
	"./DRAGONBALL/pikkon.png": 40009,
	"./DRAGONBALL/pilaf.png": 20111,
	"./DRAGONBALL/puar.png": 79652,
	"./DRAGONBALL/raditz.png": 66893,
	"./DRAGONBALL/recoome.png": 90039,
	"./DRAGONBALL/saibamen.png": 44751,
	"./DRAGONBALL/shenron.png": 393,
	"./DRAGONBALL/super_c17.png": 60122,
	"./DRAGONBALL/tao_bai_bai.png": 70533,
	"./DRAGONBALL/tien.png": 85879,
	"./DRAGONBALL/ultimate_gohan.png": 40619,
	"./DRAGONBALL/uub.png": 22239,
	"./DRAGONBALL/vegeta.png": 20878,
	"./DRAGONBALL/vegeta_ssj.png": 43243,
	"./DRAGONBALL/vegeta_ssj4.png": 70475,
	"./DRAGONBALL/vegeta_ssj_blue.png": 29562,
	"./DRAGONBALL/vegito.png": 87708,
	"./DRAGONBALL/videl.png": 85525,
	"./DRAGONBALL/whis.png": 73036,
	"./DRAGONBALL/yajirobe.png": 84011,
	"./DRAGONBALL/yamcha.png": 33336,
	"./DRAGONBALL/young_trunks.png": 63191,
	"./DRAGONBALL/zamasu.png": 52686,
	"./DRAGONBALL/zarbon.png": 79101,
	"./DRAGONBALL/zeno.png": 70750,
	"./FOODS/apple.png": 52865,
	"./FOODS/asparagus.png": 96297,
	"./FOODS/avocado.png": 58852,
	"./FOODS/bacon.png": 5715,
	"./FOODS/banana.png": 36729,
	"./FOODS/beer.png": 12526,
	"./FOODS/blueberries.png": 66011,
	"./FOODS/bread.png": 48896,
	"./FOODS/broccoli.png": 92572,
	"./FOODS/cabbage.png": 80390,
	"./FOODS/carrot.png": 74490,
	"./FOODS/cereals.png": 37669,
	"./FOODS/cheese.png": 16443,
	"./FOODS/cherry.png": 64351,
	"./FOODS/chicken.png": 20317,
	"./FOODS/chili_pepper.png": 34145,
	"./FOODS/chocolate.png": 43900,
	"./FOODS/cocktail.png": 38798,
	"./FOODS/coconut.png": 16927,
	"./FOODS/coffee.png": 84274,
	"./FOODS/cookies.png": 20974,
	"./FOODS/corn.png": 99673,
	"./FOODS/cotton_candy.png": 84098,
	"./FOODS/crab.png": 19812,
	"./FOODS/croissant.png": 80765,
	"./FOODS/cucumber.png": 25357,
	"./FOODS/cupcake.png": 44196,
	"./FOODS/dim_sum.png": 89185,
	"./FOODS/doughnut.png": 19867,
	"./FOODS/dragon_fruit.png": 72454,
	"./FOODS/egg.png": 56377,
	"./FOODS/eggplant.png": 67094,
	"./FOODS/frappe.png": 62912,
	"./FOODS/french_fries.png": 92819,
	"./FOODS/garlic.png": 73592,
	"./FOODS/gingerbread.png": 28106,
	"./FOODS/grapes.png": 35553,
	"./FOODS/hamburger.png": 52390,
	"./FOODS/hazelnut.png": 67127,
	"./FOODS/honey.png": 64062,
	"./FOODS/hot_dog.png": 5101,
	"./FOODS/ice_cream.png": 68890,
	"./FOODS/kebab.png": 92297,
	"./FOODS/kiwi.png": 55504,
	"./FOODS/lemon.png": 42490,
	"./FOODS/lettuce.png": 80461,
	"./FOODS/macaron.png": 71359,
	"./FOODS/melon.png": 50071,
	"./FOODS/milk.png": 82495,
	"./FOODS/mushrooms.png": 20405,
	"./FOODS/nachos.png": 4963,
	"./FOODS/noodles.png": 13694,
	"./FOODS/olive_oil.png": 88328,
	"./FOODS/olives.png": 83890,
	"./FOODS/onion.png": 37468,
	"./FOODS/orange.png": 80440,
	"./FOODS/pancake.png": 74831,
	"./FOODS/peach.png": 1748,
	"./FOODS/peanuts.png": 77247,
	"./FOODS/pear.png": 15366,
	"./FOODS/peas.png": 41976,
	"./FOODS/pepper.png": 65253,
	"./FOODS/pineapple.png": 65198,
	"./FOODS/pizza.png": 25947,
	"./FOODS/plum.png": 97485,
	"./FOODS/pomegranate.png": 33631,
	"./FOODS/potato.png": 98203,
	"./FOODS/prawn.png": 41472,
	"./FOODS/pretzel.png": 3100,
	"./FOODS/pumpkin.png": 60875,
	"./FOODS/rack_of_lamb.png": 60025,
	"./FOODS/radish.png": 98048,
	"./FOODS/raspberry.png": 83769,
	"./FOODS/rice.png": 42455,
	"./FOODS/salmon.png": 60823,
	"./FOODS/salt.png": 34753,
	"./FOODS/sausage.png": 69286,
	"./FOODS/spaghetti.png": 98864,
	"./FOODS/steak.png": 13750,
	"./FOODS/strawberry.png": 47491,
	"./FOODS/sugar.png": 73235,
	"./FOODS/sushi.png": 87902,
	"./FOODS/sweet_pepper.png": 84979,
	"./FOODS/taco.png": 75373,
	"./FOODS/tea.png": 57795,
	"./FOODS/tomato.png": 77285,
	"./FOODS/water.png": 71727,
	"./FOODS/watermelon.png": 65569,
	"./FOODS/wine.png": 97880,
	"./FOODS/wrap.png": 87451,
	"./HALLOWEEN/alien.png": 54031,
	"./HALLOWEEN/annabelle.png": 99838,
	"./HALLOWEEN/babadook.png": 18470,
	"./HALLOWEEN/barrel.png": 95927,
	"./HALLOWEEN/bat.png": 66505,
	"./HALLOWEEN/billy.png": 88756,
	"./HALLOWEEN/black_cat.png": 8709,
	"./HALLOWEEN/brahms.png": 8158,
	"./HALLOWEEN/candies.png": 2519,
	"./HALLOWEEN/casper.png": 44518,
	"./HALLOWEEN/chucky.png": 2186,
	"./HALLOWEEN/coffin.png": 15963,
	"./HALLOWEEN/cousin_itt.png": 29377,
	"./HALLOWEEN/creepy_baby_mask.png": 196,
	"./HALLOWEEN/crow.png": 64632,
	"./HALLOWEEN/devil.png": 24011,
	"./HALLOWEEN/dr_finkelstein.png": 33306,
	"./HALLOWEEN/dracula.png": 32851,
	"./HALLOWEEN/emily.png": 14064,
	"./HALLOWEEN/fatso.png": 41711,
	"./HALLOWEEN/frank.png": 44730,
	"./HALLOWEEN/frankenstein_monster.png": 19734,
	"./HALLOWEEN/freddy.png": 53093,
	"./HALLOWEEN/full_moon.png": 62113,
	"./HALLOWEEN/ghost.png": 46298,
	"./HALLOWEEN/ghostface.png": 53206,
	"./HALLOWEEN/gomez_addams.png": 4101,
	"./HALLOWEEN/grandmama.png": 31857,
	"./HALLOWEEN/halloween_pumpkin.png": 30078,
	"./HALLOWEEN/hand.png": 90870,
	"./HALLOWEEN/hannibal.png": 40712,
	"./HALLOWEEN/haunted_house.png": 76931,
	"./HALLOWEEN/head_in_jar.png": 25525,
	"./HALLOWEEN/headless_horseman.png": 2654,
	"./HALLOWEEN/jack.png": 19366,
	"./HALLOWEEN/jack_torrance.png": 47882,
	"./HALLOWEEN/jason_voorhees.png": 72853,
	"./HALLOWEEN/leatherface.png": 11169,
	"./HALLOWEEN/leprechaun.png": 91054,
	"./HALLOWEEN/lock.png": 45092,
	"./HALLOWEEN/lurch.png": 33494,
	"./HALLOWEEN/magic_ball.png": 11653,
	"./HALLOWEEN/magic_broom.png": 76278,
	"./HALLOWEEN/mayor.png": 51508,
	"./HALLOWEEN/michael_myers.png": 31391,
	"./HALLOWEEN/momo.png": 59590,
	"./HALLOWEEN/monster_eye.png": 25589,
	"./HALLOWEEN/morticia.png": 15348,
	"./HALLOWEEN/mummy.png": 55041,
	"./HALLOWEEN/norman_bates.png": 55527,
	"./HALLOWEEN/oogie_boogie.png": 53609,
	"./HALLOWEEN/ouija_board.png": 43751,
	"./HALLOWEEN/owl.png": 3953,
	"./HALLOWEEN/paper_bag_mask.png": 27003,
	"./HALLOWEEN/pennywise_1990.png": 85485,
	"./HALLOWEEN/pennywise_2017.png": 56748,
	"./HALLOWEEN/pinhead.png": 54840,
	"./HALLOWEEN/potion_of_poison.png": 47606,
	"./HALLOWEEN/predator.png": 9089,
	"./HALLOWEEN/pugsley.png": 82103,
	"./HALLOWEEN/reaper.png": 76314,
	"./HALLOWEEN/regan_macneil.png": 88918,
	"./HALLOWEEN/sally.png": 1362,
	"./HALLOWEEN/samara.png": 14008,
	"./HALLOWEEN/scarecrow.png": 29918,
	"./HALLOWEEN/shock.png": 65723,
	"./HALLOWEEN/skull.png": 23407,
	"./HALLOWEEN/slappy.png": 51284,
	"./HALLOWEEN/slender_man.png": 60083,
	"./HALLOWEEN/spider.png": 20207,
	"./HALLOWEEN/stinkie.png": 94518,
	"./HALLOWEEN/stretch.png": 94699,
	"./HALLOWEEN/the_beast.png": 38621,
	"./HALLOWEEN/the_nun.png": 1749,
	"./HALLOWEEN/the_purge_mask_god.png": 14715,
	"./HALLOWEEN/the_purge_mask_happy.png": 21715,
	"./HALLOWEEN/the_purge_mask_kissme.png": 18702,
	"./HALLOWEEN/the_purge_mask_lights.png": 291,
	"./HALLOWEEN/tomb.png": 91780,
	"./HALLOWEEN/uncle_fester.png": 95033,
	"./HALLOWEEN/vampire_teeth.png": 59025,
	"./HALLOWEEN/victor.png": 67934,
	"./HALLOWEEN/voodoo_doll.png": 95570,
	"./HALLOWEEN/wednesday.png": 74812,
	"./HALLOWEEN/werewolf.png": 61257,
	"./HALLOWEEN/witch.png": 729,
	"./HALLOWEEN/witch_cauldron.png": 22211,
	"./HALLOWEEN/witch_hat.png": 96523,
	"./HALLOWEEN/zero.png": 51916,
	"./HALLOWEEN/zombie.png": 10454,
	"./HEARTHSTONE/abomination.png": 74428,
	"./HEARTHSTONE/alexstrasza.png": 1017,
	"./HEARTHSTONE/altruis_the_outcast.png": 61339,
	"./HEARTHSTONE/ancient_of_lore.png": 75027,
	"./HEARTHSTONE/ancient_of_war.png": 55731,
	"./HEARTHSTONE/angry_chicken.png": 71147,
	"./HEARTHSTONE/archmage_antonidas.png": 9009,
	"./HEARTHSTONE/archvillain_rafaam.png": 9965,
	"./HEARTHSTONE/argent_squire.png": 22748,
	"./HEARTHSTONE/bad_luck_albatross.png": 88098,
	"./HEARTHSTONE/barnes.png": 72379,
	"./HEARTHSTONE/baron_geddon.png": 37954,
	"./HEARTHSTONE/big_game_hunter.png": 48491,
	"./HEARTHSTONE/bloodmage_thalnos.png": 84937,
	"./HEARTHSTONE/bluegill_warrior.png": 72156,
	"./HEARTHSTONE/boulderfist_ogre.png": 54688,
	"./HEARTHSTONE/brann_bronzebeard.png": 96458,
	"./HEARTHSTONE/cabal_shadow_priest.png": 53161,
	"./HEARTHSTONE/captain_greenskin.png": 43059,
	"./HEARTHSTONE/cenarius.png": 75323,
	"./HEARTHSTONE/chef_nomi.png": 76913,
	"./HEARTHSTONE/chillwind_yeti.png": 84678,
	"./HEARTHSTONE/cthun.png": 27055,
	"./HEARTHSTONE/deathwing.png": 92794,
	"./HEARTHSTONE/defender_of_argus.png": 21702,
	"./HEARTHSTONE/dirty_rat.png": 67311,
	"./HEARTHSTONE/doomsayer.png": 7442,
	"./HEARTHSTONE/dr_boom.png": 26117,
	"./HEARTHSTONE/edwin_vancleef.png": 93625,
	"./HEARTHSTONE/elise_the_enlightened.png": 55497,
	"./HEARTHSTONE/exotic_mountseller.png": 38391,
	"./HEARTHSTONE/flame_imp.png": 16964,
	"./HEARTHSTONE/frog.png": 2366,
	"./HEARTHSTONE/frothing_berserker.png": 46468,
	"./HEARTHSTONE/gadgetzan_auctioneer.png": 68585,
	"./HEARTHSTONE/gnomish_inventor.png": 38273,
	"./HEARTHSTONE/grommash_hellscream.png": 61731,
	"./HEARTHSTONE/harrison_jones.png": 48625,
	"./HEARTHSTONE/headmaster_kelthuzad.png": 18251,
	"./HEARTHSTONE/heistbaron_togwaggle.png": 44639,
	"./HEARTHSTONE/hogger.png": 58782,
	"./HEARTHSTONE/houndmaster.png": 95505,
	"./HEARTHSTONE/ironbeak_owl.png": 73983,
	"./HEARTHSTONE/jandice_barov.png": 3244,
	"./HEARTHSTONE/kaelthas_sunstrider.png": 41918,
	"./HEARTHSTONE/kalecgos.png": 99070,
	"./HEARTHSTONE/khadgar.png": 2873,
	"./HEARTHSTONE/king_krush.png": 29962,
	"./HEARTHSTONE/king_mukla.png": 7800,
	"./HEARTHSTONE/king_phaoris.png": 79537,
	"./HEARTHSTONE/kirin_tor_mage.png": 39935,
	"./HEARTHSTONE/knife_juggler.png": 41073,
	"./HEARTHSTONE/kronx_dragonhoof.png": 3430,
	"./HEARTHSTONE/leeroy_jenkins.png": 18507,
	"./HEARTHSTONE/leper_gnome.png": 97685,
	"./HEARTHSTONE/lord_jaraxxus.png": 70283,
	"./HEARTHSTONE/lorewalker_cho.png": 36806,
	"./HEARTHSTONE/malygos.png": 97161,
	"./HEARTHSTONE/mana_tide_totem.png": 90083,
	"./HEARTHSTONE/medivh_the_guardian.png": 44897,
	"./HEARTHSTONE/millhouse_manastorm.png": 6316,
	"./HEARTHSTONE/mind_control_tech.png": 86373,
	"./HEARTHSTONE/molten_giant.png": 77721,
	"./HEARTHSTONE/mountain_giant.png": 19755,
	"./HEARTHSTONE/mr_bigglesworth.png": 37339,
	"./HEARTHSTONE/nat_pagle.png": 44062,
	"./HEARTHSTONE/nozari.png": 11100,
	"./HEARTHSTONE/nozdormu.png": 68880,
	"./HEARTHSTONE/onyxia.png": 6248,
	"./HEARTHSTONE/patches_the_pirate.png": 44690,
	"./HEARTHSTONE/ragnaros.png": 61875,
	"./HEARTHSTONE/reno_the_relicologist.png": 65594,
	"./HEARTHSTONE/savannah_highmane.png": 61707,
	"./HEARTHSTONE/sea_giant.png": 85790,
	"./HEARTHSTONE/senjin_shieldmasta.png": 27102,
	"./HEARTHSTONE/sheep.png": 2669,
	"./HEARTHSTONE/shudderwock.png": 45315,
	"./HEARTHSTONE/si7_agent.png": 80451,
	"./HEARTHSTONE/siamat.png": 88826,
	"./HEARTHSTONE/sindragosa.png": 55221,
	"./HEARTHSTONE/sky_genral_kragg.png": 58708,
	"./HEARTHSTONE/snowflipper_penguin.png": 62317,
	"./HEARTHSTONE/sorcerers_apprentice.png": 57352,
	"./HEARTHSTONE/stranglethorn_tiger.png": 78259,
	"./HEARTHSTONE/sylvanas_windrunner.png": 66236,
	"./HEARTHSTONE/tess_greymane.png": 50361,
	"./HEARTHSTONE/the_black_knight.png": 92163,
	"./HEARTHSTONE/the_lich_king.png": 26070,
	"./HEARTHSTONE/tinkmaster_overspark.png": 2141,
	"./HEARTHSTONE/tirion_fordring.png": 17679,
	"./HEARTHSTONE/twilight_drake.png": 74220,
	"./HEARTHSTONE/water_elemental.png": 23827,
	"./HEARTHSTONE/wisp.png": 847,
	"./HEARTHSTONE/yoggsaron.png": 71242,
	"./HEARTHSTONE/ysera.png": 44188,
	"./HISTORICAL_FIGURES/abraham_lincoln.png": 33808,
	"./HISTORICAL_FIGURES/ada_lovelace.png": 94498,
	"./HISTORICAL_FIGURES/adam_smith.png": 20894,
	"./HISTORICAL_FIGURES/adolf_hitler.png": 23718,
	"./HISTORICAL_FIGURES/agatha_christie.png": 44017,
	"./HISTORICAL_FIGURES/albert_einstein.png": 39263,
	"./HISTORICAL_FIGURES/alexander_hamilton.png": 42972,
	"./HISTORICAL_FIGURES/amelia_earhart.png": 14648,
	"./HISTORICAL_FIGURES/andrew_jackson.png": 32456,
	"./HISTORICAL_FIGURES/anne_frank.png": 43856,
	"./HISTORICAL_FIGURES/barack_obama.png": 34458,
	"./HISTORICAL_FIGURES/benjamin_franklin.png": 29987,
	"./HISTORICAL_FIGURES/bill_clinton.png": 76473,
	"./HISTORICAL_FIGURES/bruce_lee.png": 37502,
	"./HISTORICAL_FIGURES/cesar_chavez.png": 46653,
	"./HISTORICAL_FIGURES/charles_darwin.png": 15230,
	"./HISTORICAL_FIGURES/charles_dickens.png": 24517,
	"./HISTORICAL_FIGURES/che_guevara.png": 8360,
	"./HISTORICAL_FIGURES/christopher_columbus.png": 99566,
	"./HISTORICAL_FIGURES/cleopatra.png": 8085,
	"./HISTORICAL_FIGURES/copernicus.png": 10242,
	"./HISTORICAL_FIGURES/edgar_allan_poe.png": 28573,
	"./HISTORICAL_FIGURES/eleanor_roosevelt.png": 42899,
	"./HISTORICAL_FIGURES/elvis_presley.png": 92161,
	"./HISTORICAL_FIGURES/emily_dickinson.png": 87666,
	"./HISTORICAL_FIGURES/franklin_d_roosevelt.png": 55440,
	"./HISTORICAL_FIGURES/frederick_douglass.png": 52885,
	"./HISTORICAL_FIGURES/frida_kahlo.png": 17608,
	"./HISTORICAL_FIGURES/galileo_galilei.png": 8843,
	"./HISTORICAL_FIGURES/george_washington.png": 73538,
	"./HISTORICAL_FIGURES/georgia_okeeffe.png": 81408,
	"./HISTORICAL_FIGURES/grace_hopper.png": 72777,
	"./HISTORICAL_FIGURES/hammurabi_laws.png": 47265,
	"./HISTORICAL_FIGURES/harvey_milk.png": 49123,
	"./HISTORICAL_FIGURES/helen_keller.png": 76300,
	"./HISTORICAL_FIGURES/henry_hudson.png": 56762,
	"./HISTORICAL_FIGURES/homer.png": 74878,
	"./HISTORICAL_FIGURES/ibn_al_haytham.png": 66951,
	"./HISTORICAL_FIGURES/isaac_newton.png": 80805,
	"./HISTORICAL_FIGURES/jackie_robinson.png": 91800,
	"./HISTORICAL_FIGURES/jacques_cousteau.png": 85551,
	"./HISTORICAL_FIGURES/james_madison.png": 76548,
	"./HISTORICAL_FIGURES/jane_goodall.png": 39288,
	"./HISTORICAL_FIGURES/john_adams.png": 29011,
	"./HISTORICAL_FIGURES/john_f_kennedy.png": 89425,
	"./HISTORICAL_FIGURES/jrr_tolkien.png": 89585,
	"./HISTORICAL_FIGURES/judy_blume.png": 2850,
	"./HISTORICAL_FIGURES/kurt_vonnegut.png": 96511,
	"./HISTORICAL_FIGURES/langston_hughes.png": 18021,
	"./HISTORICAL_FIGURES/leonardo_da_vinci.png": 35633,
	"./HISTORICAL_FIGURES/louis_armstrong.png": 60249,
	"./HISTORICAL_FIGURES/ludwig_van_beethoven.png": 26444,
	"./HISTORICAL_FIGURES/madam_cj_walker.png": 14525,
	"./HISTORICAL_FIGURES/mahatma_gandhi.png": 25474,
	"./HISTORICAL_FIGURES/malcolm_x.png": 29194,
	"./HISTORICAL_FIGURES/mansa_musa.png": 21115,
	"./HISTORICAL_FIGURES/marco_polo.png": 2372,
	"./HISTORICAL_FIGURES/marie_curie.png": 44674,
	"./HISTORICAL_FIGURES/mark_twain.png": 4583,
	"./HISTORICAL_FIGURES/martin_luther_king_jr.png": 67029,
	"./HISTORICAL_FIGURES/maya_angelou.png": 65061,
	"./HISTORICAL_FIGURES/maya_lin.png": 95671,
	"./HISTORICAL_FIGURES/michelangelo_buonarroti.png": 11168,
	"./HISTORICAL_FIGURES/muhammad_ali.png": 94230,
	"./HISTORICAL_FIGURES/napoleon_bonaparte.png": 17310,
	"./HISTORICAL_FIGURES/nellie_bly.png": 52442,
	"./HISTORICAL_FIGURES/nikola_tesla.png": 87042,
	"./HISTORICAL_FIGURES/pablo_neruda.png": 1194,
	"./HISTORICAL_FIGURES/pele.png": 566,
	"./HISTORICAL_FIGURES/pocahontas.png": 79824,
	"./HISTORICAL_FIGURES/queen_elizabeth_i.png": 10058,
	"./HISTORICAL_FIGURES/queen_elizabeth_ii.png": 88748,
	"./HISTORICAL_FIGURES/queen_liliuokalani.png": 99005,
	"./HISTORICAL_FIGURES/rachel_carson.png": 29546,
	"./HISTORICAL_FIGURES/richard_nixon.png": 81049,
	"./HISTORICAL_FIGURES/roald_dahl.png": 24527,
	"./HISTORICAL_FIGURES/ronald_reagan.png": 67965,
	"./HISTORICAL_FIGURES/sally_ride.png": 19793,
	"./HISTORICAL_FIGURES/simon_bolivar.png": 60316,
	"./HISTORICAL_FIGURES/tecumseh.png": 26361,
	"./HISTORICAL_FIGURES/the_beatles.png": 50713,
	"./HISTORICAL_FIGURES/theodore_roosevelt.png": 55713,
	"./HISTORICAL_FIGURES/thomas_edison.png": 40578,
	"./HISTORICAL_FIGURES/thomas_jefferson.png": 33316,
	"./HISTORICAL_FIGURES/wangari_maathai.png": 72175,
	"./HISTORICAL_FIGURES/william_shakespeare.png": 1548,
	"./HISTORICAL_FIGURES/wolfgang_amadeus_mozart.png": 87124,
	"./HISTORICAL_FIGURES/wright_brothers.png": 53663,
	"./HISTORICAL_FIGURES/yo_yo_ma.png": 78533,
	"./HISTORICAL_FIGURES/zaha_hadid.png": 92995,
	"./LEAGUE_OF_LEGENDS/aatrox.png": 5772,
	"./LEAGUE_OF_LEGENDS/ahri.png": 10169,
	"./LEAGUE_OF_LEGENDS/akali.png": 97184,
	"./LEAGUE_OF_LEGENDS/alistar.png": 6124,
	"./LEAGUE_OF_LEGENDS/amumu.png": 76839,
	"./LEAGUE_OF_LEGENDS/annie.png": 69730,
	"./LEAGUE_OF_LEGENDS/ashe.png": 37363,
	"./LEAGUE_OF_LEGENDS/blitzcrank.png": 76789,
	"./LEAGUE_OF_LEGENDS/brand.png": 60422,
	"./LEAGUE_OF_LEGENDS/caitlyn.png": 42150,
	"./LEAGUE_OF_LEGENDS/camille.png": 51732,
	"./LEAGUE_OF_LEGENDS/chogath.png": 69412,
	"./LEAGUE_OF_LEGENDS/darius.png": 81127,
	"./LEAGUE_OF_LEGENDS/ekko.png": 93061,
	"./LEAGUE_OF_LEGENDS/elise.png": 91758,
	"./LEAGUE_OF_LEGENDS/ezreal.png": 1859,
	"./LEAGUE_OF_LEGENDS/fiddlesticks.png": 42244,
	"./LEAGUE_OF_LEGENDS/fiora.png": 35968,
	"./LEAGUE_OF_LEGENDS/galio.png": 34004,
	"./LEAGUE_OF_LEGENDS/gangplank.png": 33867,
	"./LEAGUE_OF_LEGENDS/garen.png": 54889,
	"./LEAGUE_OF_LEGENDS/gragas.png": 17667,
	"./LEAGUE_OF_LEGENDS/graves.png": 74253,
	"./LEAGUE_OF_LEGENDS/heimerdinger.png": 84761,
	"./LEAGUE_OF_LEGENDS/irelia.png": 11897,
	"./LEAGUE_OF_LEGENDS/jarvan_iv.png": 47692,
	"./LEAGUE_OF_LEGENDS/jax.png": 1250,
	"./LEAGUE_OF_LEGENDS/jayce.png": 44466,
	"./LEAGUE_OF_LEGENDS/jhin.png": 67181,
	"./LEAGUE_OF_LEGENDS/jinx.png": 47411,
	"./LEAGUE_OF_LEGENDS/kaisa.png": 39885,
	"./LEAGUE_OF_LEGENDS/karthus.png": 78079,
	"./LEAGUE_OF_LEGENDS/kassadin.png": 98385,
	"./LEAGUE_OF_LEGENDS/katarina.png": 70641,
	"./LEAGUE_OF_LEGENDS/kayle.png": 2014,
	"./LEAGUE_OF_LEGENDS/kennen.png": 46151,
	"./LEAGUE_OF_LEGENDS/kogmaw.png": 58073,
	"./LEAGUE_OF_LEGENDS/leblanc.png": 15040,
	"./LEAGUE_OF_LEGENDS/lee_sin.png": 80124,
	"./LEAGUE_OF_LEGENDS/leona.png": 22998,
	"./LEAGUE_OF_LEGENDS/lucian.png": 6175,
	"./LEAGUE_OF_LEGENDS/lulu.png": 62863,
	"./LEAGUE_OF_LEGENDS/lux.png": 91255,
	"./LEAGUE_OF_LEGENDS/malphite.png": 50783,
	"./LEAGUE_OF_LEGENDS/maokai.png": 34887,
	"./LEAGUE_OF_LEGENDS/master_yi.png": 59422,
	"./LEAGUE_OF_LEGENDS/miss_fortune.png": 28222,
	"./LEAGUE_OF_LEGENDS/mordekaiser.png": 20426,
	"./LEAGUE_OF_LEGENDS/morgana.png": 99176,
	"./LEAGUE_OF_LEGENDS/nasus.png": 16530,
	"./LEAGUE_OF_LEGENDS/nautilus.png": 74108,
	"./LEAGUE_OF_LEGENDS/nidalee.png": 38398,
	"./LEAGUE_OF_LEGENDS/nocturne.png": 63141,
	"./LEAGUE_OF_LEGENDS/nunu_&_willump.png": 87045,
	"./LEAGUE_OF_LEGENDS/olaf.png": 51113,
	"./LEAGUE_OF_LEGENDS/pantheon.png": 81700,
	"./LEAGUE_OF_LEGENDS/poppy.png": 88653,
	"./LEAGUE_OF_LEGENDS/pyke.png": 10711,
	"./LEAGUE_OF_LEGENDS/qiyana.png": 70239,
	"./LEAGUE_OF_LEGENDS/rammus.png": 72298,
	"./LEAGUE_OF_LEGENDS/renekton.png": 51665,
	"./LEAGUE_OF_LEGENDS/rengar.png": 23079,
	"./LEAGUE_OF_LEGENDS/riven.png": 43829,
	"./LEAGUE_OF_LEGENDS/ryze.png": 89738,
	"./LEAGUE_OF_LEGENDS/senna.png": 90068,
	"./LEAGUE_OF_LEGENDS/sett.png": 53405,
	"./LEAGUE_OF_LEGENDS/shaco.png": 90114,
	"./LEAGUE_OF_LEGENDS/shen.png": 77349,
	"./LEAGUE_OF_LEGENDS/singed.png": 47047,
	"./LEAGUE_OF_LEGENDS/sivir.png": 996,
	"./LEAGUE_OF_LEGENDS/sona.png": 81012,
	"./LEAGUE_OF_LEGENDS/soraka.png": 68601,
	"./LEAGUE_OF_LEGENDS/sylas.png": 67649,
	"./LEAGUE_OF_LEGENDS/syndra.png": 74867,
	"./LEAGUE_OF_LEGENDS/teemo.png": 23818,
	"./LEAGUE_OF_LEGENDS/thresh.png": 63813,
	"./LEAGUE_OF_LEGENDS/tristana.png": 79897,
	"./LEAGUE_OF_LEGENDS/tryndamere.png": 96138,
	"./LEAGUE_OF_LEGENDS/twisted_fate.png": 90186,
	"./LEAGUE_OF_LEGENDS/urgot.png": 89555,
	"./LEAGUE_OF_LEGENDS/vayne.png": 90352,
	"./LEAGUE_OF_LEGENDS/veigar.png": 46108,
	"./LEAGUE_OF_LEGENDS/vi.png": 3440,
	"./LEAGUE_OF_LEGENDS/vladimir.png": 93777,
	"./LEAGUE_OF_LEGENDS/volibear.png": 85783,
	"./LEAGUE_OF_LEGENDS/warwick.png": 54524,
	"./LEAGUE_OF_LEGENDS/yasuo.png": 71103,
	"./LEAGUE_OF_LEGENDS/zac.png": 83363,
	"./LEAGUE_OF_LEGENDS/zed.png": 73453,
	"./LEAGUE_OF_LEGENDS/zilean.png": 79914,
	"./MELAGOODO/BEKYM.png": 47319,
	"./MELAGOODO/BLUR.png": 20130,
	"./MELAGOODO/CHAKRA.png": 49090,
	"./MELAGOODO/DANIBATTLE_E_FITZA.png": 24513,
	"./MELAGOODO/DELUX.png": 56090,
	"./MELAGOODO/DREAD.png": 80070,
	"./MELAGOODO/FAZZ.png": 72916,
	"./MELAGOODO/FRENEZY.png": 3294,
	"./MELAGOODO/GABBO.png": 83613,
	"./MELAGOODO/GIANKO.png": 2538,
	"./MELAGOODO/JOHNNY_CREEK.png": 71348,
	"./MELAGOODO/JTAZ.png": 1412,
	"./MELAGOODO/MARZA.png": 10762,
	"./MELAGOODO/MASSEO.png": 90463,
	"./MELAGOODO/MELAGOODO.png": 69699,
	"./MELAGOODO/MICHELLE.png": 86284,
	"./MELAGOODO/MOLLU.png": 1943,
	"./MELAGOODO/ROHN.png": 39460,
	"./MELAGOODO/SOFIA.png": 99425,
	"./MELAGOODO/ZANO.png": 38684,
	"./MELAGOODO/chakraBit.png": 73787,
	"./MELAGOODO/chakraEhm.png": 85636,
	"./MELAGOODO/chakraFlauto.png": 18792,
	"./MELAGOODO/chakraFotto.png": 26573,
	"./MELAGOODO/chakraFuoco.png": 1583,
	"./MELAGOODO/deluBobbi.png": 60181,
	"./MELAGOODO/deluHarmane.png": 96780,
	"./MELAGOODO/deluPesce.png": 47222,
	"./MELAGOODO/deluPog.png": 3214,
	"./MELAGOODO/deluShop.png": 92329,
	"./MELAGOODO/dreadDread.png": 1216,
	"./MELAGOODO/dreadEuro.png": 55204,
	"./MELAGOODO/dreadLasciaPerde.png": 13070,
	"./MELAGOODO/dreadNala.png": 63872,
	"./MELAGOODO/dreadRigolo.png": 16721,
	"./MELAGOODO/faz025.png": 38470,
	"./MELAGOODO/fazM.png": 71295,
	"./MELAGOODO/fazMonika.png": 18107,
	"./MELAGOODO/fazPollice.png": 73205,
	"./MELAGOODO/fazUe.png": 57548,
	"./MELAGOODO/freneAkimbo.png": 77722,
	"./MELAGOODO/freneEclisse.png": 6883,
	"./MELAGOODO/freneItas.png": 52443,
	"./MELAGOODO/freneMogano.png": 97670,
	"./MELAGOODO/freneScam.png": 24872,
	"./MELAGOODO/gabboGuaddi.png": 65765,
	"./MELAGOODO/gabboNonno.png": 58586,
	"./MELAGOODO/gabboOke.png": 63568,
	"./MELAGOODO/gabboPaky.png": 75461,
	"./MELAGOODO/gabboSonno.png": 61765,
	"./MELAGOODO/giankoAttacco.png": 60631,
	"./MELAGOODO/giankoPog.png": 34869,
	"./MELAGOODO/giankoRivolta.png": 26046,
	"./MELAGOODO/giankoSleeper.png": 50947,
	"./MELAGOODO/giankoTifo.png": 9912,
	"./MELAGOODO/ilmassCursed.png": 3089,
	"./MELAGOODO/ilmassDancer.png": 87265,
	"./MELAGOODO/ilmassHU.png": 97126,
	"./MELAGOODO/ilmassP.png": 50820,
	"./MELAGOODO/ilmassSchei.png": 9806,
	"./MELAGOODO/jtazAww.png": 76129,
	"./MELAGOODO/jtazMiao.png": 17083,
	"./MELAGOODO/jtazPeluche.png": 89018,
	"./MELAGOODO/jtazWow.png": 54782,
	"./MELAGOODO/jtazZugu.png": 43701,
	"./MELAGOODO/marzaAhri.png": 51303,
	"./MELAGOODO/marzaMadre.png": 52866,
	"./MELAGOODO/marzaPiscio.png": 41504,
	"./MELAGOODO/marzaSigaretta.png": 72377,
	"./MELAGOODO/marzaTrimone.png": 28841,
	"./MELAGOODO/molluApproved.png": 90539,
	"./MELAGOODO/molluC.png": 5437,
	"./MELAGOODO/molluDissocio.png": 21557,
	"./MELAGOODO/molluGasm.png": 56464,
	"./MELAGOODO/molluPoo.png": 75287,
	"./MELAGOODO/rohnCry.png": 53091,
	"./MELAGOODO/rohnGrrr.png": 16127,
	"./MELAGOODO/rohnKiss.png": 36681,
	"./MELAGOODO/rohnOuch.png": 99494,
	"./MELAGOODO/rohnPOGGERS.png": 20764,
	"./MELAGOODO/tumbluClown.png": 67591,
	"./MELAGOODO/tumbluEmoteDelFazzone.png": 15695,
	"./MELAGOODO/tumbluGgggggg.png": 73910,
	"./MELAGOODO/tumbluHamburgerona.png": 95344,
	"./MELAGOODO/tumbluSium.png": 79106,
	"./MELAGOODO/zanoATHENA.png": 10961,
	"./MELAGOODO/zanoLove.png": 5573,
	"./MELAGOODO/zanoNext.png": 44417,
	"./MELAGOODO/zanoShop.png": 3826,
	"./MELAGOODO/zanoWe.png": 6662,
	"./POKEMON/abra.png": 14971,
	"./POKEMON/aerodactyl.png": 86375,
	"./POKEMON/arbok.png": 83256,
	"./POKEMON/arcanine.png": 67020,
	"./POKEMON/articuno.png": 18600,
	"./POKEMON/bellsprout.png": 9936,
	"./POKEMON/blastoise.png": 94187,
	"./POKEMON/bulbasaur.png": 29645,
	"./POKEMON/caterpie.png": 62300,
	"./POKEMON/chansey.png": 68205,
	"./POKEMON/charizard.png": 45154,
	"./POKEMON/charmander.png": 62538,
	"./POKEMON/charmeleon.png": 84442,
	"./POKEMON/clefable.png": 51709,
	"./POKEMON/cloyster.png": 68169,
	"./POKEMON/diglett.png": 94563,
	"./POKEMON/ditto.png": 44522,
	"./POKEMON/doduo.png": 26997,
	"./POKEMON/dragonite.png": 79277,
	"./POKEMON/drowzee.png": 98693,
	"./POKEMON/eevee.png": 51815,
	"./POKEMON/electabuzz.png": 57264,
	"./POKEMON/exeggcute.png": 12847,
	"./POKEMON/farfetchd.png": 38810,
	"./POKEMON/flareon.png": 3561,
	"./POKEMON/gengar.png": 68864,
	"./POKEMON/geodude.png": 71024,
	"./POKEMON/goldeen.png": 19904,
	"./POKEMON/gyarados.png": 93805,
	"./POKEMON/hitmonchan.png": 25314,
	"./POKEMON/hitmonlee.png": 28804,
	"./POKEMON/horsea.png": 24472,
	"./POKEMON/ivysaur.png": 1839,
	"./POKEMON/jigglypuff.png": 35815,
	"./POKEMON/jolteon.png": 59145,
	"./POKEMON/jynx.png": 53719,
	"./POKEMON/kabuto.png": 98274,
	"./POKEMON/kangaskhan.png": 78613,
	"./POKEMON/krabby.png": 64227,
	"./POKEMON/lapras.png": 5591,
	"./POKEMON/lickitung.png": 93919,
	"./POKEMON/machop.png": 98955,
	"./POKEMON/magikarp.png": 25408,
	"./POKEMON/magmar.png": 86393,
	"./POKEMON/magnemite.png": 26700,
	"./POKEMON/marowak.png": 52059,
	"./POKEMON/meowth.png": 59649,
	"./POKEMON/metapod.png": 41598,
	"./POKEMON/mew.png": 2708,
	"./POKEMON/mewtwo.png": 69382,
	"./POKEMON/moltres.png": 61625,
	"./POKEMON/mr_mime.png": 52944,
	"./POKEMON/muk.png": 56394,
	"./POKEMON/nidoking.png": 29153,
	"./POKEMON/nidoqueen.png": 75572,
	"./POKEMON/omanyte.png": 63222,
	"./POKEMON/onix.png": 31721,
	"./POKEMON/paras.png": 25325,
	"./POKEMON/pidgey.png": 36156,
	"./POKEMON/pikachu.png": 59397,
	"./POKEMON/pinsir.png": 19925,
	"./POKEMON/poliwag.png": 958,
	"./POKEMON/ponyta.png": 49864,
	"./POKEMON/porygon.png": 50892,
	"./POKEMON/primeape.png": 61925,
	"./POKEMON/psyduck.png": 15620,
	"./POKEMON/raichu.png": 65826,
	"./POKEMON/rattata.png": 25931,
	"./POKEMON/rhydon.png": 64875,
	"./POKEMON/sandshrew.png": 73594,
	"./POKEMON/scyther.png": 15560,
	"./POKEMON/seel.png": 5325,
	"./POKEMON/slowpoke.png": 14894,
	"./POKEMON/snorlax.png": 75718,
	"./POKEMON/spearow.png": 87825,
	"./POKEMON/squirtle.png": 32964,
	"./POKEMON/starmie.png": 76674,
	"./POKEMON/tangela.png": 94576,
	"./POKEMON/tauros.png": 35,
	"./POKEMON/tentacool.png": 86683,
	"./POKEMON/vaporeon.png": 24006,
	"./POKEMON/venonat.png": 79029,
	"./POKEMON/venusaur.png": 94828,
	"./POKEMON/vileplume.png": 56682,
	"./POKEMON/voltorb.png": 69295,
	"./POKEMON/vulpix.png": 31414,
	"./POKEMON/wartotle.png": 76430,
	"./POKEMON/weedle.png": 72190,
	"./POKEMON/weezing.png": 59203,
	"./POKEMON/zapdos.png": 74448,
	"./POKEMON/zubat.png": 57126,
	"./POKEMON_GEN2/aipom.png": 32128,
	"./POKEMON_GEN2/ampharos.png": 76861,
	"./POKEMON_GEN2/ariados.png": 48635,
	"./POKEMON_GEN2/bayleef.png": 17905,
	"./POKEMON_GEN2/bellossom.png": 11490,
	"./POKEMON_GEN2/blissey.png": 24205,
	"./POKEMON_GEN2/celebi.png": 75743,
	"./POKEMON_GEN2/chikorita.png": 47986,
	"./POKEMON_GEN2/chinchou.png": 5169,
	"./POKEMON_GEN2/cleffa.png": 13697,
	"./POKEMON_GEN2/corsola.png": 26385,
	"./POKEMON_GEN2/crobat.png": 28322,
	"./POKEMON_GEN2/croconaw.png": 20444,
	"./POKEMON_GEN2/cyndaquil.png": 34875,
	"./POKEMON_GEN2/delibird.png": 85736,
	"./POKEMON_GEN2/donphan.png": 74675,
	"./POKEMON_GEN2/dunsparce.png": 17277,
	"./POKEMON_GEN2/elekid.png": 57648,
	"./POKEMON_GEN2/entei.png": 61600,
	"./POKEMON_GEN2/espeon.png": 97978,
	"./POKEMON_GEN2/feraligatr.png": 86674,
	"./POKEMON_GEN2/flaaffy.png": 20123,
	"./POKEMON_GEN2/girafarig.png": 40532,
	"./POKEMON_GEN2/gligar.png": 42614,
	"./POKEMON_GEN2/heracross.png": 31687,
	"./POKEMON_GEN2/hitmontop.png": 13680,
	"./POKEMON_GEN2/hooh.png": 25507,
	"./POKEMON_GEN2/hoothoot.png": 63155,
	"./POKEMON_GEN2/hoppip.png": 26106,
	"./POKEMON_GEN2/houndoom.png": 29612,
	"./POKEMON_GEN2/igglybuff.png": 8818,
	"./POKEMON_GEN2/jumpluff.png": 18134,
	"./POKEMON_GEN2/kingdra.png": 7995,
	"./POKEMON_GEN2/lanturn.png": 46818,
	"./POKEMON_GEN2/larvitar.png": 77302,
	"./POKEMON_GEN2/ledian.png": 81524,
	"./POKEMON_GEN2/ledyba.png": 33516,
	"./POKEMON_GEN2/lugia.png": 23044,
	"./POKEMON_GEN2/magby.png": 96757,
	"./POKEMON_GEN2/magcargo.png": 65914,
	"./POKEMON_GEN2/mantine.png": 69243,
	"./POKEMON_GEN2/mareep.png": 91139,
	"./POKEMON_GEN2/marill.png": 32593,
	"./POKEMON_GEN2/meganium.png": 25978,
	"./POKEMON_GEN2/miltank.png": 2501,
	"./POKEMON_GEN2/misdreavus.png": 95879,
	"./POKEMON_GEN2/murkrow.png": 35835,
	"./POKEMON_GEN2/natu.png": 29241,
	"./POKEMON_GEN2/noctowl.png": 2001,
	"./POKEMON_GEN2/octillery.png": 41826,
	"./POKEMON_GEN2/phanpy.png": 72723,
	"./POKEMON_GEN2/pichu.png": 25159,
	"./POKEMON_GEN2/piloswine.png": 33829,
	"./POKEMON_GEN2/pineco.png": 159,
	"./POKEMON_GEN2/politoed.png": 84244,
	"./POKEMON_GEN2/porygon2.png": 23993,
	"./POKEMON_GEN2/pupitar.png": 72357,
	"./POKEMON_GEN2/quilava.png": 33716,
	"./POKEMON_GEN2/qwilfish.png": 25827,
	"./POKEMON_GEN2/raikou.png": 4329,
	"./POKEMON_GEN2/remoraid.png": 46953,
	"./POKEMON_GEN2/scizor.png": 95873,
	"./POKEMON_GEN2/sentret.png": 40862,
	"./POKEMON_GEN2/shuckle.png": 76392,
	"./POKEMON_GEN2/skarmory.png": 94336,
	"./POKEMON_GEN2/slowking.png": 38856,
	"./POKEMON_GEN2/smeargle.png": 41113,
	"./POKEMON_GEN2/smoochum.png": 26218,
	"./POKEMON_GEN2/sneasel.png": 17286,
	"./POKEMON_GEN2/snubbull.png": 67938,
	"./POKEMON_GEN2/spinarak.png": 14055,
	"./POKEMON_GEN2/stantler.png": 24255,
	"./POKEMON_GEN2/steelix.png": 69957,
	"./POKEMON_GEN2/sudowoodo.png": 24969,
	"./POKEMON_GEN2/suicune.png": 41907,
	"./POKEMON_GEN2/sunflora.png": 94832,
	"./POKEMON_GEN2/sunkern.png": 43184,
	"./POKEMON_GEN2/swinub.png": 13484,
	"./POKEMON_GEN2/teddiursa.png": 62248,
	"./POKEMON_GEN2/togepi.png": 88034,
	"./POKEMON_GEN2/totodile.png": 53801,
	"./POKEMON_GEN2/typhlosion.png": 45263,
	"./POKEMON_GEN2/tyranitar.png": 77440,
	"./POKEMON_GEN2/tyrogue.png": 11849,
	"./POKEMON_GEN2/umbreon.png": 79501,
	"./POKEMON_GEN2/unown.png": 55184,
	"./POKEMON_GEN2/ursaring.png": 24098,
	"./POKEMON_GEN2/wobbuffet.png": 88682,
	"./POKEMON_GEN2/wooper.png": 72658,
	"./POKEMON_GEN2/yanma.png": 22967,
	"./POKEMON_GEN3/Absol.png": 41213,
	"./POKEMON_GEN3/Aggron.png": 47115,
	"./POKEMON_GEN3/Altaria.png": 24963,
	"./POKEMON_GEN3/Armaldo.png": 47521,
	"./POKEMON_GEN3/Azurill.png": 71537,
	"./POKEMON_GEN3/Bagon.png": 38956,
	"./POKEMON_GEN3/Banette.png": 66230,
	"./POKEMON_GEN3/Blaziken.png": 85849,
	"./POKEMON_GEN3/Breloom.png": 38133,
	"./POKEMON_GEN3/Cacturne.png": 98025,
	"./POKEMON_GEN3/Camerupt.png": 60581,
	"./POKEMON_GEN3/Carvanha.png": 17621,
	"./POKEMON_GEN3/Castform.png": 89859,
	"./POKEMON_GEN3/Chimecho.png": 22180,
	"./POKEMON_GEN3/Clamperl.png": 52285,
	"./POKEMON_GEN3/Claydol.png": 3754,
	"./POKEMON_GEN3/Combusken.png": 68838,
	"./POKEMON_GEN3/Cradily.png": 88798,
	"./POKEMON_GEN3/Crawdaunt.png": 61047,
	"./POKEMON_GEN3/Deoxys.png": 84653,
	"./POKEMON_GEN3/Dusclops.png": 53833,
	"./POKEMON_GEN3/Exploud.png": 42269,
	"./POKEMON_GEN3/Feebas.png": 58429,
	"./POKEMON_GEN3/Flygon.png": 42847,
	"./POKEMON_GEN3/Gardevoir.png": 2969,
	"./POKEMON_GEN3/Glalie.png": 28655,
	"./POKEMON_GEN3/Gorebyss.png": 34794,
	"./POKEMON_GEN3/Groudon.png": 46810,
	"./POKEMON_GEN3/Grovyle.png": 53284,
	"./POKEMON_GEN3/Gulpin.png": 52220,
	"./POKEMON_GEN3/Hariyama.png": 15135,
	"./POKEMON_GEN3/Huntail.png": 28610,
	"./POKEMON_GEN3/Illumise.png": 97600,
	"./POKEMON_GEN3/Jirachi.png": 7840,
	"./POKEMON_GEN3/Kecleon.png": 79202,
	"./POKEMON_GEN3/Kyogre.png": 31064,
	"./POKEMON_GEN3/Latias.png": 17197,
	"./POKEMON_GEN3/Latios.png": 12064,
	"./POKEMON_GEN3/Ludicolo.png": 31661,
	"./POKEMON_GEN3/Lunatone.png": 26543,
	"./POKEMON_GEN3/Luvdisc.png": 77857,
	"./POKEMON_GEN3/Manectric.png": 36394,
	"./POKEMON_GEN3/Marshtomp.png": 84229,
	"./POKEMON_GEN3/Masquerain.png": 33510,
	"./POKEMON_GEN3/Mawile.png": 25249,
	"./POKEMON_GEN3/Medicham.png": 15228,
	"./POKEMON_GEN3/Metagross.png": 17970,
	"./POKEMON_GEN3/Milotic.png": 91584,
	"./POKEMON_GEN3/Minun.png": 17563,
	"./POKEMON_GEN3/Mudkip.png": 28041,
	"./POKEMON_GEN3/Ninjask.png": 72179,
	"./POKEMON_GEN3/Nosepass.png": 41382,
	"./POKEMON_GEN3/Nuzleaf.png": 51138,
	"./POKEMON_GEN3/Pelipper.png": 10926,
	"./POKEMON_GEN3/Plusle.png": 53286,
	"./POKEMON_GEN3/Poochyena.png": 88103,
	"./POKEMON_GEN3/Rayquaza.png": 2249,
	"./POKEMON_GEN3/Regice.png": 89000,
	"./POKEMON_GEN3/Regirock.png": 86320,
	"./POKEMON_GEN3/Registeel.png": 67843,
	"./POKEMON_GEN3/Relicanth.png": 55651,
	"./POKEMON_GEN3/Roselia.png": 54846,
	"./POKEMON_GEN3/Sableye.png": 24094,
	"./POKEMON_GEN3/Salamence.png": 16268,
	"./POKEMON_GEN3/Sceptile.png": 61960,
	"./POKEMON_GEN3/Seviper.png": 68255,
	"./POKEMON_GEN3/Sharpedo.png": 45089,
	"./POKEMON_GEN3/Shedinja.png": 57061,
	"./POKEMON_GEN3/Shelgon.png": 5943,
	"./POKEMON_GEN3/Skitty.png": 34376,
	"./POKEMON_GEN3/Slaking.png": 50689,
	"./POKEMON_GEN3/Solrock.png": 16146,
	"./POKEMON_GEN3/Spheal.png": 99310,
	"./POKEMON_GEN3/Spinda.png": 35484,
	"./POKEMON_GEN3/Spoink.png": 55463,
	"./POKEMON_GEN3/Swampert.png": 39040,
	"./POKEMON_GEN3/Taillow.png": 34989,
	"./POKEMON_GEN3/Torchic.png": 9538,
	"./POKEMON_GEN3/Torkoal.png": 61667,
	"./POKEMON_GEN3/Trapinch.png": 84362,
	"./POKEMON_GEN3/Treecko.png": 49855,
	"./POKEMON_GEN3/Tropius.png": 29980,
	"./POKEMON_GEN3/Volbeat.png": 76837,
	"./POKEMON_GEN3/Wailord.png": 61077,
	"./POKEMON_GEN3/Walrein.png": 27409,
	"./POKEMON_GEN3/Whiscash.png": 9410,
	"./POKEMON_GEN3/Wurmple.png": 90316,
	"./POKEMON_GEN3/Wynaut.png": 12814,
	"./POKEMON_GEN3/Zangoose.png": 68140,
	"./POKEMON_GEN3/Zigzagoon.png": 22715,
	"./POKEMON_GEN4/Abomasnow.png": 34885,
	"./POKEMON_GEN4/Ambipom.png": 15696,
	"./POKEMON_GEN4/Arceus.png": 85914,
	"./POKEMON_GEN4/Azelf.png": 80106,
	"./POKEMON_GEN4/Bastiodon.png": 33044,
	"./POKEMON_GEN4/Bibarel.png": 39061,
	"./POKEMON_GEN4/Bidoof.png": 49445,
	"./POKEMON_GEN4/Bonsly.png": 63531,
	"./POKEMON_GEN4/Bronzong.png": 47453,
	"./POKEMON_GEN4/Bronzor.png": 23445,
	"./POKEMON_GEN4/Budew.png": 71085,
	"./POKEMON_GEN4/Burmy.png": 54003,
	"./POKEMON_GEN4/Carnivine.png": 69780,
	"./POKEMON_GEN4/Chatot.png": 14511,
	"./POKEMON_GEN4/Cherubi.png": 43049,
	"./POKEMON_GEN4/Chimchar.png": 43540,
	"./POKEMON_GEN4/Chingling.png": 13924,
	"./POKEMON_GEN4/Combee.png": 52024,
	"./POKEMON_GEN4/Cranidos.png": 26873,
	"./POKEMON_GEN4/Cresselia.png": 5684,
	"./POKEMON_GEN4/Croagunk.png": 61520,
	"./POKEMON_GEN4/Darkrai.png": 42771,
	"./POKEMON_GEN4/Dialga.png": 49063,
	"./POKEMON_GEN4/Drapion.png": 32318,
	"./POKEMON_GEN4/Drifloon.png": 83038,
	"./POKEMON_GEN4/Dusknoir.png": 12460,
	"./POKEMON_GEN4/Electivire.png": 94931,
	"./POKEMON_GEN4/Empoleon.png": 46765,
	"./POKEMON_GEN4/Floatzel.png": 19388,
	"./POKEMON_GEN4/Froslass.png": 65295,
	"./POKEMON_GEN4/Gallade.png": 43839,
	"./POKEMON_GEN4/Garchomp.png": 43631,
	"./POKEMON_GEN4/Gastrodon.png": 18030,
	"./POKEMON_GEN4/Gible.png": 47867,
	"./POKEMON_GEN4/Giratina.png": 24847,
	"./POKEMON_GEN4/Glaceon.png": 28812,
	"./POKEMON_GEN4/Gliscor.png": 5286,
	"./POKEMON_GEN4/Grotle.png": 41731,
	"./POKEMON_GEN4/Happiny.png": 76143,
	"./POKEMON_GEN4/Heatran.png": 806,
	"./POKEMON_GEN4/Hippopotas.png": 395,
	"./POKEMON_GEN4/Hippowdon.png": 14776,
	"./POKEMON_GEN4/Honchkrow.png": 42726,
	"./POKEMON_GEN4/Infernape.png": 13875,
	"./POKEMON_GEN4/Kricketune.png": 72774,
	"./POKEMON_GEN4/Leafeon.png": 57507,
	"./POKEMON_GEN4/Lickilicky.png": 42289,
	"./POKEMON_GEN4/Lopunny.png": 62615,
	"./POKEMON_GEN4/Lucario.png": 51633,
	"./POKEMON_GEN4/Lumineon.png": 84658,
	"./POKEMON_GEN4/Luxray.png": 44750,
	"./POKEMON_GEN4/Magmortar.png": 6541,
	"./POKEMON_GEN4/Magnezone.png": 82572,
	"./POKEMON_GEN4/Mamoswine.png": 12336,
	"./POKEMON_GEN4/Manaphy.png": 86239,
	"./POKEMON_GEN4/Mantyke.png": 49998,
	"./POKEMON_GEN4/Mesprit.png": 63974,
	"./POKEMON_GEN4/Mime-Jr.png": 32347,
	"./POKEMON_GEN4/Mismagius.png": 15,
	"./POKEMON_GEN4/Monferno.png": 96450,
	"./POKEMON_GEN4/Mothim.png": 77825,
	"./POKEMON_GEN4/Munchlax.png": 35277,
	"./POKEMON_GEN4/Pachirisu.png": 27363,
	"./POKEMON_GEN4/Palkia.png": 70912,
	"./POKEMON_GEN4/Phione.png": 49799,
	"./POKEMON_GEN4/Piplup.png": 9387,
	"./POKEMON_GEN4/Porygon-Z.png": 38395,
	"./POKEMON_GEN4/Prinplup.png": 91770,
	"./POKEMON_GEN4/Probopass.png": 85897,
	"./POKEMON_GEN4/Purugly.png": 76909,
	"./POKEMON_GEN4/Rampardos.png": 11624,
	"./POKEMON_GEN4/Regigigas.png": 61154,
	"./POKEMON_GEN4/Rhyperior.png": 95278,
	"./POKEMON_GEN4/Riolu.png": 90373,
	"./POKEMON_GEN4/Roserade.png": 23479,
	"./POKEMON_GEN4/Rotom.png": 76094,
	"./POKEMON_GEN4/Shaymin.png": 94885,
	"./POKEMON_GEN4/Shinx.png": 95777,
	"./POKEMON_GEN4/Spiritomb.png": 54561,
	"./POKEMON_GEN4/Staraptor.png": 19594,
	"./POKEMON_GEN4/Starly.png": 65062,
	"./POKEMON_GEN4/Stunky.png": 85760,
	"./POKEMON_GEN4/Tangrowth.png": 65509,
	"./POKEMON_GEN4/Togekiss.png": 96938,
	"./POKEMON_GEN4/Torterra.png": 72213,
	"./POKEMON_GEN4/Turtwig.png": 27951,
	"./POKEMON_GEN4/Uxie.png": 78523,
	"./POKEMON_GEN4/Vespiquen.png": 21751,
	"./POKEMON_GEN4/Weavile.png": 74717,
	"./POKEMON_GEN4/Yanmega.png": 81609,
	"./POKEMON_GEN5/494.png": 11161,
	"./POKEMON_GEN5/495.png": 5631,
	"./POKEMON_GEN5/496.png": 97243,
	"./POKEMON_GEN5/497.png": 75288,
	"./POKEMON_GEN5/498.png": 39374,
	"./POKEMON_GEN5/499.png": 91987,
	"./POKEMON_GEN5/500.png": 93951,
	"./POKEMON_GEN5/501.png": 73610,
	"./POKEMON_GEN5/502.png": 19521,
	"./POKEMON_GEN5/503.png": 10803,
	"./POKEMON_GEN5/504.png": 79766,
	"./POKEMON_GEN5/506.png": 29402,
	"./POKEMON_GEN5/509.png": 95250,
	"./POKEMON_GEN5/511.png": 29479,
	"./POKEMON_GEN5/513.png": 13945,
	"./POKEMON_GEN5/515.png": 17091,
	"./POKEMON_GEN5/518.png": 30785,
	"./POKEMON_GEN5/521.png": 79221,
	"./POKEMON_GEN5/523.png": 7439,
	"./POKEMON_GEN5/526.png": 15034,
	"./POKEMON_GEN5/528.png": 48173,
	"./POKEMON_GEN5/530.png": 32112,
	"./POKEMON_GEN5/531.png": 93030,
	"./POKEMON_GEN5/534.png": 97306,
	"./POKEMON_GEN5/537.png": 81042,
	"./POKEMON_GEN5/538.png": 99589,
	"./POKEMON_GEN5/539.png": 99691,
	"./POKEMON_GEN5/542.png": 79356,
	"./POKEMON_GEN5/545.png": 36616,
	"./POKEMON_GEN5/547.png": 84934,
	"./POKEMON_GEN5/549.png": 74630,
	"./POKEMON_GEN5/550.png": 84474,
	"./POKEMON_GEN5/553.png": 7481,
	"./POKEMON_GEN5/555.png": 16538,
	"./POKEMON_GEN5/556.png": 26953,
	"./POKEMON_GEN5/558.png": 88740,
	"./POKEMON_GEN5/559.png": 15523,
	"./POKEMON_GEN5/561.png": 47259,
	"./POKEMON_GEN5/563.png": 37283,
	"./POKEMON_GEN5/565.png": 36233,
	"./POKEMON_GEN5/567.png": 76375,
	"./POKEMON_GEN5/569.png": 62433,
	"./POKEMON_GEN5/570.png": 56995,
	"./POKEMON_GEN5/571.png": 71252,
	"./POKEMON_GEN5/573.png": 99640,
	"./POKEMON_GEN5/576.png": 67055,
	"./POKEMON_GEN5/579.png": 15098,
	"./POKEMON_GEN5/581.png": 20522,
	"./POKEMON_GEN5/584.png": 26446,
	"./POKEMON_GEN5/585.png": 88239,
	"./POKEMON_GEN5/586.png": 29858,
	"./POKEMON_GEN5/587.png": 25080,
	"./POKEMON_GEN5/589.png": 1504,
	"./POKEMON_GEN5/591.png": 84035,
	"./POKEMON_GEN5/593.png": 57037,
	"./POKEMON_GEN5/594.png": 24706,
	"./POKEMON_GEN5/596.png": 53584,
	"./POKEMON_GEN5/598.png": 35200,
	"./POKEMON_GEN5/599.png": 84660,
	"./POKEMON_GEN5/604.png": 15203,
	"./POKEMON_GEN5/605.png": 86018,
	"./POKEMON_GEN5/609.png": 67731,
	"./POKEMON_GEN5/612.png": 64538,
	"./POKEMON_GEN5/613.png": 68260,
	"./POKEMON_GEN5/615.png": 31639,
	"./POKEMON_GEN5/616.png": 98431,
	"./POKEMON_GEN5/618.png": 80549,
	"./POKEMON_GEN5/619.png": 6225,
	"./POKEMON_GEN5/621.png": 87304,
	"./POKEMON_GEN5/623.png": 63123,
	"./POKEMON_GEN5/625.png": 83648,
	"./POKEMON_GEN5/626.png": 32196,
	"./POKEMON_GEN5/628.png": 23561,
	"./POKEMON_GEN5/630.png": 13928,
	"./POKEMON_GEN5/631.png": 41588,
	"./POKEMON_GEN5/632.png": 61654,
	"./POKEMON_GEN5/635.png": 48923,
	"./POKEMON_GEN5/637.png": 20914,
	"./POKEMON_GEN5/638.png": 77348,
	"./POKEMON_GEN5/639.png": 79580,
	"./POKEMON_GEN5/640.png": 89931,
	"./POKEMON_GEN5/641.png": 59749,
	"./POKEMON_GEN5/642.png": 35447,
	"./POKEMON_GEN5/643.png": 72341,
	"./POKEMON_GEN5/644.png": 56528,
	"./POKEMON_GEN5/645.png": 70195,
	"./POKEMON_GEN5/646.png": 84881,
	"./POKEMON_GEN5/647.png": 16429,
	"./POKEMON_GEN5/648.png": 96279,
	"./POKEMON_GEN5/649.png": 33100,
	"./POKEMON_GEN6/000_09.png": 71267,
	"./POKEMON_GEN6/000_10.png": 95359,
	"./POKEMON_GEN6/000_11.png": 24305,
	"./POKEMON_GEN6/000_12.png": 83682,
	"./POKEMON_GEN6/000_15.png": 64045,
	"./POKEMON_GEN6/000_17.png": 61813,
	"./POKEMON_GEN6/000_18.png": 34895,
	"./POKEMON_GEN6/000_20.png": 41515,
	"./POKEMON_GEN6/000_22.png": 11826,
	"./POKEMON_GEN6/000_23.png": 73903,
	"./POKEMON_GEN6/000_24.png": 98604,
	"./POKEMON_GEN6/000_25.png": 5307,
	"./POKEMON_GEN6/000_38.png": 12624,
	"./POKEMON_GEN6/000_44.png": 80811,
	"./POKEMON_GEN6/000_46.png": 47805,
	"./POKEMON_GEN6/000_49.png": 37079,
	"./POKEMON_GEN6/000_51.png": 85028,
	"./POKEMON_GEN6/000_52.png": 12049,
	"./POKEMON_GEN6/650.png": 95549,
	"./POKEMON_GEN6/651.png": 61314,
	"./POKEMON_GEN6/652.png": 46329,
	"./POKEMON_GEN6/653.png": 67249,
	"./POKEMON_GEN6/654.png": 77452,
	"./POKEMON_GEN6/655.png": 7013,
	"./POKEMON_GEN6/656.png": 45564,
	"./POKEMON_GEN6/657.png": 20185,
	"./POKEMON_GEN6/658.png": 68646,
	"./POKEMON_GEN6/659.png": 95426,
	"./POKEMON_GEN6/660.png": 80480,
	"./POKEMON_GEN6/661.png": 96533,
	"./POKEMON_GEN6/662.png": 51485,
	"./POKEMON_GEN6/663.png": 23957,
	"./POKEMON_GEN6/664.png": 7627,
	"./POKEMON_GEN6/665.png": 68875,
	"./POKEMON_GEN6/666.png": 54719,
	"./POKEMON_GEN6/667.png": 21583,
	"./POKEMON_GEN6/668.png": 83434,
	"./POKEMON_GEN6/669.png": 24728,
	"./POKEMON_GEN6/670.png": 42922,
	"./POKEMON_GEN6/671.png": 94236,
	"./POKEMON_GEN6/672.png": 91949,
	"./POKEMON_GEN6/673.png": 61779,
	"./POKEMON_GEN6/674.png": 1497,
	"./POKEMON_GEN6/675.png": 87203,
	"./POKEMON_GEN6/676.png": 54095,
	"./POKEMON_GEN6/677.png": 82570,
	"./POKEMON_GEN6/678.png": 62885,
	"./POKEMON_GEN6/679.png": 18950,
	"./POKEMON_GEN6/680.png": 63718,
	"./POKEMON_GEN6/681.png": 33922,
	"./POKEMON_GEN6/682.png": 81287,
	"./POKEMON_GEN6/683.png": 79160,
	"./POKEMON_GEN6/684.png": 19622,
	"./POKEMON_GEN6/685.png": 49561,
	"./POKEMON_GEN6/686.png": 73629,
	"./POKEMON_GEN6/687.png": 44512,
	"./POKEMON_GEN6/688.png": 60063,
	"./POKEMON_GEN6/689.png": 14125,
	"./POKEMON_GEN6/690.png": 86424,
	"./POKEMON_GEN6/691.png": 12163,
	"./POKEMON_GEN6/692.png": 95711,
	"./POKEMON_GEN6/693.png": 45628,
	"./POKEMON_GEN6/694.png": 55836,
	"./POKEMON_GEN6/695.png": 55458,
	"./POKEMON_GEN6/696.png": 43312,
	"./POKEMON_GEN6/697.png": 74770,
	"./POKEMON_GEN6/698.png": 88450,
	"./POKEMON_GEN6/699.png": 93293,
	"./POKEMON_GEN6/700.png": 89377,
	"./POKEMON_GEN6/701.png": 21840,
	"./POKEMON_GEN6/702.png": 22142,
	"./POKEMON_GEN6/703.png": 5827,
	"./POKEMON_GEN6/704.png": 67734,
	"./POKEMON_GEN6/705.png": 95729,
	"./POKEMON_GEN6/706.png": 85934,
	"./POKEMON_GEN6/707.png": 18247,
	"./POKEMON_GEN6/708.png": 63609,
	"./POKEMON_GEN6/709.png": 90960,
	"./POKEMON_GEN6/710.png": 36316,
	"./POKEMON_GEN6/711.png": 43542,
	"./POKEMON_GEN6/712.png": 98950,
	"./POKEMON_GEN6/713.png": 86659,
	"./POKEMON_GEN6/714.png": 2843,
	"./POKEMON_GEN6/715.png": 34116,
	"./POKEMON_GEN6/716.png": 44885,
	"./POKEMON_GEN6/717.png": 6934,
	"./POKEMON_GEN6/718.png": 32808,
	"./POKEMON_GEN6/719.png": 16973,
	"./POKEMON_GEN6/720.png": 19441,
	"./POKEMON_GEN6/721.png": 35939,
	"./POKEMON_GEN7/020_01.png": 73291,
	"./POKEMON_GEN7/026_02.png": 71079,
	"./POKEMON_GEN7/027_01.png": 28114,
	"./POKEMON_GEN7/037_01.png": 25530,
	"./POKEMON_GEN7/051_01.png": 52889,
	"./POKEMON_GEN7/052_01.png": 26458,
	"./POKEMON_GEN7/074_01.png": 67269,
	"./POKEMON_GEN7/089_01.png": 22875,
	"./POKEMON_GEN7/103_01.png": 29859,
	"./POKEMON_GEN7/105_01.png": 71431,
	"./POKEMON_GEN7/722.png": 38218,
	"./POKEMON_GEN7/723.png": 26925,
	"./POKEMON_GEN7/724.png": 15908,
	"./POKEMON_GEN7/725.png": 15939,
	"./POKEMON_GEN7/726.png": 8273,
	"./POKEMON_GEN7/727.png": 36140,
	"./POKEMON_GEN7/728.png": 19235,
	"./POKEMON_GEN7/729.png": 49271,
	"./POKEMON_GEN7/730.png": 63689,
	"./POKEMON_GEN7/731.png": 98277,
	"./POKEMON_GEN7/733.png": 93804,
	"./POKEMON_GEN7/734.png": 96007,
	"./POKEMON_GEN7/736.png": 27665,
	"./POKEMON_GEN7/738.png": 9837,
	"./POKEMON_GEN7/740.png": 7386,
	"./POKEMON_GEN7/741.png": 23169,
	"./POKEMON_GEN7/742.png": 97417,
	"./POKEMON_GEN7/743.png": 48396,
	"./POKEMON_GEN7/744.png": 95655,
	"./POKEMON_GEN7/745.png": 17987,
	"./POKEMON_GEN7/746.png": 81353,
	"./POKEMON_GEN7/748.png": 49543,
	"./POKEMON_GEN7/749.png": 57642,
	"./POKEMON_GEN7/750.png": 48720,
	"./POKEMON_GEN7/751.png": 44838,
	"./POKEMON_GEN7/752.png": 65792,
	"./POKEMON_GEN7/753.png": 26388,
	"./POKEMON_GEN7/754.png": 26854,
	"./POKEMON_GEN7/755.png": 81086,
	"./POKEMON_GEN7/756.png": 40914,
	"./POKEMON_GEN7/757.png": 61764,
	"./POKEMON_GEN7/758.png": 18698,
	"./POKEMON_GEN7/760.png": 21429,
	"./POKEMON_GEN7/761.png": 42739,
	"./POKEMON_GEN7/763.png": 19349,
	"./POKEMON_GEN7/764.png": 9075,
	"./POKEMON_GEN7/765.png": 1599,
	"./POKEMON_GEN7/766.png": 28653,
	"./POKEMON_GEN7/767.png": 69937,
	"./POKEMON_GEN7/768.png": 43668,
	"./POKEMON_GEN7/769.png": 49484,
	"./POKEMON_GEN7/770.png": 2889,
	"./POKEMON_GEN7/771.png": 59020,
	"./POKEMON_GEN7/772.png": 81530,
	"./POKEMON_GEN7/773.png": 26958,
	"./POKEMON_GEN7/774.png": 43009,
	"./POKEMON_GEN7/775.png": 13772,
	"./POKEMON_GEN7/776.png": 44119,
	"./POKEMON_GEN7/777.png": 55837,
	"./POKEMON_GEN7/778.png": 2505,
	"./POKEMON_GEN7/779.png": 71093,
	"./POKEMON_GEN7/780.png": 11640,
	"./POKEMON_GEN7/781.png": 66594,
	"./POKEMON_GEN7/782.png": 89460,
	"./POKEMON_GEN7/783.png": 61000,
	"./POKEMON_GEN7/784.png": 5850,
	"./POKEMON_GEN7/785.png": 97616,
	"./POKEMON_GEN7/786.png": 55899,
	"./POKEMON_GEN7/787.png": 58440,
	"./POKEMON_GEN7/788.png": 57080,
	"./POKEMON_GEN7/789.png": 47884,
	"./POKEMON_GEN7/790.png": 38995,
	"./POKEMON_GEN7/791.png": 59617,
	"./POKEMON_GEN7/792.png": 55016,
	"./POKEMON_GEN7/793.png": 59838,
	"./POKEMON_GEN7/794.png": 14038,
	"./POKEMON_GEN7/795.png": 80952,
	"./POKEMON_GEN7/796.png": 20958,
	"./POKEMON_GEN7/797.png": 66175,
	"./POKEMON_GEN7/798.png": 78737,
	"./POKEMON_GEN7/799.png": 10851,
	"./POKEMON_GEN7/800.png": 46856,
	"./POKEMON_GEN7/801.png": 20649,
	"./POKEMON_GEN7/802.png": 58304,
	"./POKEMON_GEN7/803.png": 2295,
	"./POKEMON_GEN7/805.png": 33431,
	"./POKEMON_GEN7/806.png": 26979,
	"./POKEMON_GEN7/807.png": 80865,
	"./POKEMON_GEN7/808.png": 76612,
	"./POKEMON_GEN7/809.png": 73654,
	"./SIMPSONS/abe_simpson.png": 17968,
	"./SIMPSONS/agnes_skinner.png": 67285,
	"./SIMPSONS/apu_nahasapeemapetilon.png": 54678,
	"./SIMPSONS/artie_ziff.png": 29776,
	"./SIMPSONS/baby_gerald.png": 59063,
	"./SIMPSONS/barney_grumble.png": 59087,
	"./SIMPSONS/bart_simpson.png": 77201,
	"./SIMPSONS/bleeding_gums_murphy.png": 18916,
	"./SIMPSONS/blue_haired_lawyer.png": 82770,
	"./SIMPSONS/brandine.png": 92875,
	"./SIMPSONS/bumblebee_man.png": 47300,
	"./SIMPSONS/captain_mccallister.png": 76869,
	"./SIMPSONS/carl_carlson.png": 88013,
	"./SIMPSONS/chief_wiggum.png": 33788,
	"./SIMPSONS/cletus.png": 9029,
	"./SIMPSONS/comic_book_guy.png": 68363,
	"./SIMPSONS/crazy_cat_lady.png": 92603,
	"./SIMPSONS/database.png": 36234,
	"./SIMPSONS/disco_stu.png": 88589,
	"./SIMPSONS/dolph.png": 63590,
	"./SIMPSONS/dr_hibbert.png": 22505,
	"./SIMPSONS/dr_nick_riviera.png": 26937,
	"./SIMPSONS/drederick_tatum.png": 15125,
	"./SIMPSONS/duff_man.png": 23613,
	"./SIMPSONS/edna_krabappel.png": 43390,
	"./SIMPSONS/elizabeth_hoover.png": 38875,
	"./SIMPSONS/fat_tony.png": 43574,
	"./SIMPSONS/frank_grimes_jr.png": 26392,
	"./SIMPSONS/gil.png": 61221,
	"./SIMPSONS/hank_scorpio.png": 72205,
	"./SIMPSONS/hans_moleman.png": 39063,
	"./SIMPSONS/helen_lovejoy.png": 17223,
	"./SIMPSONS/herman_hermann.png": 21018,
	"./SIMPSONS/homer_simpson.png": 97632,
	"./SIMPSONS/itchy.png": 24976,
	"./SIMPSONS/jasper_beardsley.png": 44982,
	"./SIMPSONS/jimbo_jones.png": 27946,
	"./SIMPSONS/judge_constance_harm.png": 50404,
	"./SIMPSONS/judge_snyder.png": 81911,
	"./SIMPSONS/kang.png": 71061,
	"./SIMPSONS/kearney.png": 62988,
	"./SIMPSONS/kent_brockman.png": 75642,
	"./SIMPSONS/kirk_van_houten.png": 47647,
	"./SIMPSONS/krusty_the_clown.png": 68769,
	"./SIMPSONS/lenny_leonard.png": 98792,
	"./SIMPSONS/lionel_hutz.png": 57413,
	"./SIMPSONS/lisa_simpson.png": 50551,
	"./SIMPSONS/luann_van_houten.png": 68394,
	"./SIMPSONS/luigi.png": 70917,
	"./SIMPSONS/lunchlady_doris.png": 15765,
	"./SIMPSONS/maggie_simpson.png": 6473,
	"./SIMPSONS/manjula_nahasapeemapetilon.png": 54750,
	"./SIMPSONS/marge_simpson.png": 81163,
	"./SIMPSONS/martin_prince.png": 56590,
	"./SIMPSONS/maude_flanders.png": 18822,
	"./SIMPSONS/mayor_joe_quimby.png": 77114,
	"./SIMPSONS/millhouse_van_houten.png": 96248,
	"./SIMPSONS/moe.png": 18323,
	"./SIMPSONS/mr_burns.png": 84320,
	"./SIMPSONS/mr_largo.png": 80374,
	"./SIMPSONS/mr_teeny.png": 36764,
	"./SIMPSONS/mrs_wiggum.png": 54068,
	"./SIMPSONS/ned_flanders.png": 40988,
	"./SIMPSONS/nelson_muntz.png": 7485,
	"./SIMPSONS/officer_lou.png": 74125,
	"./SIMPSONS/otto_mann.png": 65923,
	"./SIMPSONS/patty_bouvier.png": 84369,
	"./SIMPSONS/plopper.png": 79179,
	"./SIMPSONS/principal_skinner.png": 96309,
	"./SIMPSONS/professor_frink.png": 28677,
	"./SIMPSONS/rainier_wolfcastle.png": 98488,
	"./SIMPSONS/ralph_wiggum.png": 76949,
	"./SIMPSONS/reverend_lovejoy.png": 48724,
	"./SIMPSONS/rick_texan.png": 41059,
	"./SIMPSONS/rod_flanders.png": 7740,
	"./SIMPSONS/santa_little_helper.png": 47479,
	"./SIMPSONS/scratchy.png": 73729,
	"./SIMPSONS/selma_bouvier.png": 21637,
	"./SIMPSONS/sideshow_bob.png": 35726,
	"./SIMPSONS/sideshow_mel.png": 14202,
	"./SIMPSONS/snake.png": 13391,
	"./SIMPSONS/snowball_II.png": 88205,
	"./SIMPSONS/squeaky_voiced_teen.png": 82777,
	"./SIMPSONS/superintendent_chalmers.png": 12521,
	"./SIMPSONS/todd_flanders.png": 24177,
	"./SIMPSONS/troy_mcclure.png": 95054,
	"./SIMPSONS/uter.png": 69080,
	"./SIMPSONS/waylon_smithers.png": 54196,
	"./SIMPSONS/willie.png": 62681,
	"./SIMPSONS/yes_guy.png": 71862,
	"./SMORFIA/1.png": 94539,
	"./SMORFIA/10.png": 83176,
	"./SMORFIA/11.png": 94712,
	"./SMORFIA/12.png": 42106,
	"./SMORFIA/13.png": 72525,
	"./SMORFIA/14.png": 72392,
	"./SMORFIA/15.png": 91752,
	"./SMORFIA/16.png": 99969,
	"./SMORFIA/17.png": 12831,
	"./SMORFIA/18.png": 69684,
	"./SMORFIA/19.png": 17476,
	"./SMORFIA/2.png": 22268,
	"./SMORFIA/20.png": 72840,
	"./SMORFIA/21.png": 88898,
	"./SMORFIA/22.png": 20375,
	"./SMORFIA/23.png": 11494,
	"./SMORFIA/24.png": 60459,
	"./SMORFIA/25.png": 78137,
	"./SMORFIA/26.png": 96901,
	"./SMORFIA/27.png": 73922,
	"./SMORFIA/28.png": 44526,
	"./SMORFIA/29.png": 39049,
	"./SMORFIA/3.png": 44222,
	"./SMORFIA/30.png": 54610,
	"./SMORFIA/31.png": 76763,
	"./SMORFIA/32.png": 25158,
	"./SMORFIA/33.png": 92410,
	"./SMORFIA/34.png": 27774,
	"./SMORFIA/35.png": 89020,
	"./SMORFIA/36.png": 57336,
	"./SMORFIA/37.png": 16865,
	"./SMORFIA/38.png": 43325,
	"./SMORFIA/39.png": 78424,
	"./SMORFIA/4.png": 10271,
	"./SMORFIA/40.png": 45462,
	"./SMORFIA/41.png": 12510,
	"./SMORFIA/42.png": 93415,
	"./SMORFIA/43.png": 4510,
	"./SMORFIA/44.png": 68310,
	"./SMORFIA/45.png": 96350,
	"./SMORFIA/46.png": 87862,
	"./SMORFIA/47.png": 37675,
	"./SMORFIA/48.png": 29392,
	"./SMORFIA/49.png": 32916,
	"./SMORFIA/5.png": 12166,
	"./SMORFIA/50.png": 96667,
	"./SMORFIA/51.png": 59200,
	"./SMORFIA/52.png": 19714,
	"./SMORFIA/53.png": 60322,
	"./SMORFIA/54.png": 74268,
	"./SMORFIA/55.png": 27442,
	"./SMORFIA/56.png": 42700,
	"./SMORFIA/57.png": 56615,
	"./SMORFIA/58.png": 19063,
	"./SMORFIA/59.png": 73459,
	"./SMORFIA/6.png": 36090,
	"./SMORFIA/60.png": 7104,
	"./SMORFIA/61.png": 94245,
	"./SMORFIA/62.png": 76084,
	"./SMORFIA/63.png": 71117,
	"./SMORFIA/64.png": 94427,
	"./SMORFIA/65.png": 91187,
	"./SMORFIA/66.png": 90950,
	"./SMORFIA/67.png": 7936,
	"./SMORFIA/68.png": 28264,
	"./SMORFIA/69.png": 22736,
	"./SMORFIA/7.png": 65057,
	"./SMORFIA/70.png": 40412,
	"./SMORFIA/71.png": 40521,
	"./SMORFIA/72.png": 97332,
	"./SMORFIA/73.png": 16277,
	"./SMORFIA/74.png": 71,
	"./SMORFIA/75.png": 13854,
	"./SMORFIA/76.png": 78810,
	"./SMORFIA/77.png": 92144,
	"./SMORFIA/78.png": 99199,
	"./SMORFIA/79.png": 87603,
	"./SMORFIA/8.png": 59350,
	"./SMORFIA/80.png": 7111,
	"./SMORFIA/81.png": 1304,
	"./SMORFIA/82.png": 5267,
	"./SMORFIA/83.png": 12300,
	"./SMORFIA/84.png": 10238,
	"./SMORFIA/85.png": 92434,
	"./SMORFIA/86.png": 65894,
	"./SMORFIA/87.png": 67822,
	"./SMORFIA/88.png": 30703,
	"./SMORFIA/89.png": 10809,
	"./SMORFIA/9.png": 83752,
	"./SMORFIA/90.png": 50748,
	"./SOCCER_PLAYERS/aguero.png": 88637,
	"./SOCCER_PLAYERS/alex_morgan.png": 14205,
	"./SOCCER_PLAYERS/alisson.png": 69194,
	"./SOCCER_PLAYERS/baggio.png": 77894,
	"./SOCCER_PLAYERS/bale.png": 3255,
	"./SOCCER_PLAYERS/batistuta.png": 71356,
	"./SOCCER_PLAYERS/beckenbauer.png": 74002,
	"./SOCCER_PLAYERS/beckham.png": 53918,
	"./SOCCER_PLAYERS/benzema.png": 80853,
	"./SOCCER_PLAYERS/buffon.png": 1079,
	"./SOCCER_PLAYERS/cafu.png": 64589,
	"./SOCCER_PLAYERS/cannavaro.png": 87971,
	"./SOCCER_PLAYERS/cantona.png": 75231,
	"./SOCCER_PLAYERS/carli_lloyd.png": 3909,
	"./SOCCER_PLAYERS/casillas.png": 74138,
	"./SOCCER_PLAYERS/cavani.png": 5624,
	"./SOCCER_PLAYERS/cech.png": 74296,
	"./SOCCER_PLAYERS/chiellini.png": 1406,
	"./SOCCER_PLAYERS/cristiano_ronaldo.png": 3668,
	"./SOCCER_PLAYERS/cruijff.png": 70023,
	"./SOCCER_PLAYERS/de_bruyne.png": 81566,
	"./SOCCER_PLAYERS/del_piero.png": 61288,
	"./SOCCER_PLAYERS/di_maria.png": 19936,
	"./SOCCER_PLAYERS/drogba.png": 83375,
	"./SOCCER_PLAYERS/dybala.png": 14381,
	"./SOCCER_PLAYERS/dzeko.png": 16264,
	"./SOCCER_PLAYERS/etoo.png": 52341,
	"./SOCCER_PLAYERS/figo.png": 91611,
	"./SOCCER_PLAYERS/gerrard.png": 45907,
	"./SOCCER_PLAYERS/giggs.png": 36647,
	"./SOCCER_PLAYERS/griezmann.png": 14274,
	"./SOCCER_PLAYERS/gullit.png": 25488,
	"./SOCCER_PLAYERS/haland.png": 85244,
	"./SOCCER_PLAYERS/henry.png": 27949,
	"./SOCCER_PLAYERS/ibrahimovic.png": 65785,
	"./SOCCER_PLAYERS/immobile.png": 14487,
	"./SOCCER_PLAYERS/iniesta.png": 20719,
	"./SOCCER_PLAYERS/jasin.png": 74617,
	"./SOCCER_PLAYERS/kaka.png": 55639,
	"./SOCCER_PLAYERS/kane.png": 51870,
	"./SOCCER_PLAYERS/kroos.png": 5027,
	"./SOCCER_PLAYERS/lahm.png": 64656,
	"./SOCCER_PLAYERS/lampard.png": 16685,
	"./SOCCER_PLAYERS/lewandowski.png": 76907,
	"./SOCCER_PLAYERS/lukaku.png": 55007,
	"./SOCCER_PLAYERS/maldini.png": 49058,
	"./SOCCER_PLAYERS/maradona.png": 58950,
	"./SOCCER_PLAYERS/mbappe.png": 58565,
	"./SOCCER_PLAYERS/messi.png": 71429,
	"./SOCCER_PLAYERS/modric.png": 82955,
	"./SOCCER_PLAYERS/muller.png": 44133,
	"./SOCCER_PLAYERS/nedved.png": 98781,
	"./SOCCER_PLAYERS/neuer.png": 15163,
	"./SOCCER_PLAYERS/neymar.png": 3447,
	"./SOCCER_PLAYERS/oblak.png": 41947,
	"./SOCCER_PLAYERS/owen.png": 59862,
	"./SOCCER_PLAYERS/ozil.png": 65557,
	"./SOCCER_PLAYERS/pele.png": 17885,
	"./SOCCER_PLAYERS/pique.png": 32535,
	"./SOCCER_PLAYERS/pirlo.png": 57851,
	"./SOCCER_PLAYERS/platini.png": 93705,
	"./SOCCER_PLAYERS/pogba.png": 30166,
	"./SOCCER_PLAYERS/puyol.png": 70355,
	"./SOCCER_PLAYERS/ramos.png": 18688,
	"./SOCCER_PLAYERS/ribery.png": 68951,
	"./SOCCER_PLAYERS/robben.png": 69969,
	"./SOCCER_PLAYERS/roberto_carlos.png": 72598,
	"./SOCCER_PLAYERS/ronaldinho.png": 46918,
	"./SOCCER_PLAYERS/ronaldo.png": 17631,
	"./SOCCER_PLAYERS/rooney.png": 535,
	"./SOCCER_PLAYERS/rummenigge.png": 64855,
	"./SOCCER_PLAYERS/salah.png": 67196,
	"./SOCCER_PLAYERS/scholes.png": 92066,
	"./SOCCER_PLAYERS/seedorf.png": 39597,
	"./SOCCER_PLAYERS/shevchenko.png": 3201,
	"./SOCCER_PLAYERS/son.png": 51528,
	"./SOCCER_PLAYERS/suarez.png": 88476,
	"./SOCCER_PLAYERS/tevez.png": 95528,
	"./SOCCER_PLAYERS/thiago_silva.png": 53493,
	"./SOCCER_PLAYERS/torres.png": 38250,
	"./SOCCER_PLAYERS/totti.png": 30527,
	"./SOCCER_PLAYERS/trezeguet.png": 29100,
	"./SOCCER_PLAYERS/van_basten.png": 91775,
	"./SOCCER_PLAYERS/van_dijk.png": 41351,
	"./SOCCER_PLAYERS/van_nistelrooy.png": 74978,
	"./SOCCER_PLAYERS/vardy.png": 84657,
	"./SOCCER_PLAYERS/vidal.png": 32067,
	"./SOCCER_PLAYERS/xavi.png": 62456,
	"./SOCCER_PLAYERS/zanetti.png": 9807,
	"./SOCCER_PLAYERS/zidane.png": 78170,
	"./SUPERHEROES/ant-man.png": 4726,
	"./SUPERHEROES/aquaman.png": 33075,
	"./SUPERHEROES/bane.png": 25179,
	"./SUPERHEROES/batman.png": 83646,
	"./SUPERHEROES/beast_boy.png": 38719,
	"./SUPERHEROES/black_panther.png": 74621,
	"./SUPERHEROES/black_widow.png": 36413,
	"./SUPERHEROES/captain_america.png": 85472,
	"./SUPERHEROES/captain_cold.png": 38640,
	"./SUPERHEROES/captain_marvel.png": 42925,
	"./SUPERHEROES/carnage.png": 22187,
	"./SUPERHEROES/catwoman.png": 76085,
	"./SUPERHEROES/colossus.png": 89012,
	"./SUPERHEROES/cyborg.png": 84596,
	"./SUPERHEROES/cyclops.png": 90871,
	"./SUPERHEROES/daredevil.png": 7542,
	"./SUPERHEROES/deadpool.png": 18293,
	"./SUPERHEROES/dormammu.png": 28746,
	"./SUPERHEROES/dr_doom.png": 57068,
	"./SUPERHEROES/dr_octopus.png": 97086,
	"./SUPERHEROES/dr_strange.png": 58756,
	"./SUPERHEROES/drax_the_destroyer.png": 11339,
	"./SUPERHEROES/elastigirl.png": 71748,
	"./SUPERHEROES/falcon.png": 25728,
	"./SUPERHEROES/flash.png": 39212,
	"./SUPERHEROES/flash_incredibles.png": 88649,
	"./SUPERHEROES/frozone.png": 44407,
	"./SUPERHEROES/galactus.png": 27180,
	"./SUPERHEROES/gambit.png": 30901,
	"./SUPERHEROES/gamora.png": 22960,
	"./SUPERHEROES/goblin.png": 17418,
	"./SUPERHEROES/green_lantern.png": 17993,
	"./SUPERHEROES/groot.png": 56270,
	"./SUPERHEROES/harley_quinn.png": 41805,
	"./SUPERHEROES/hawkeye.png": 82542,
	"./SUPERHEROES/hellblazer.png": 70102,
	"./SUPERHEROES/hellboy.png": 57056,
	"./SUPERHEROES/hulk.png": 72409,
	"./SUPERHEROES/human_torch.png": 50350,
	"./SUPERHEROES/invisible_woman.png": 97623,
	"./SUPERHEROES/iron_man.png": 83672,
	"./SUPERHEROES/jack-jack.png": 38979,
	"./SUPERHEROES/jean_grey.png": 1156,
	"./SUPERHEROES/joker.png": 33025,
	"./SUPERHEROES/judge_dredd.png": 60950,
	"./SUPERHEROES/klaw.png": 12567,
	"./SUPERHEROES/lex_luthor.png": 24605,
	"./SUPERHEROES/loki.png": 37429,
	"./SUPERHEROES/magneto.png": 82326,
	"./SUPERHEROES/martian_manhunter.png": 20788,
	"./SUPERHEROES/mr_fantastic.png": 89855,
	"./SUPERHEROES/mr_incredible.png": 79934,
	"./SUPERHEROES/nebula.png": 14801,
	"./SUPERHEROES/poison_ivy.png": 15037,
	"./SUPERHEROES/professor_x.png": 13495,
	"./SUPERHEROES/quicksilver.png": 6449,
	"./SUPERHEROES/ras_al_ghul.png": 11071,
	"./SUPERHEROES/raven.png": 13030,
	"./SUPERHEROES/red_skull.png": 88456,
	"./SUPERHEROES/reverse_flash.png": 83651,
	"./SUPERHEROES/robin.png": 78211,
	"./SUPERHEROES/rocket.png": 72995,
	"./SUPERHEROES/rorschach.png": 45662,
	"./SUPERHEROES/sandman.png": 42951,
	"./SUPERHEROES/scarecrow.png": 79071,
	"./SUPERHEROES/scarlet_witch.png": 89443,
	"./SUPERHEROES/sentry.png": 15662,
	"./SUPERHEROES/shazam.png": 87733,
	"./SUPERHEROES/silver_surfer.png": 79211,
	"./SUPERHEROES/sinestro.png": 64627,
	"./SUPERHEROES/spider-man.png": 33441,
	"./SUPERHEROES/star_lord.png": 51822,
	"./SUPERHEROES/storm.png": 63504,
	"./SUPERHEROES/superman.png": 40622,
	"./SUPERHEROES/syndrome.png": 1665,
	"./SUPERHEROES/thanos.png": 23712,
	"./SUPERHEROES/the_punisher.png": 97606,
	"./SUPERHEROES/the_thing.png": 9340,
	"./SUPERHEROES/the_vulture.png": 68157,
	"./SUPERHEROES/thor.png": 4102,
	"./SUPERHEROES/two-face.png": 52813,
	"./SUPERHEROES/ultron.png": 86419,
	"./SUPERHEROES/venom.png": 75193,
	"./SUPERHEROES/violet.png": 84248,
	"./SUPERHEROES/vision.png": 33828,
	"./SUPERHEROES/war_machine.png": 48975,
	"./SUPERHEROES/wasp.png": 75665,
	"./SUPERHEROES/wolverine.png": 40131,
	"./SUPERHEROES/wonder_woman.png": 29974,
	"./SUPERHEROES/x-23.png": 64058,
	"./TV_SERIES/arya_stark.png": 7777,
	"./TV_SERIES/barney_stinson.png": 84589,
	"./TV_SERIES/berlin.png": 48732,
	"./TV_SERIES/beth_harmon.png": 49834,
	"./TV_SERIES/billy_bob_thornton.png": 60782,
	"./TV_SERIES/bojack_horseman.png": 25002,
	"./TV_SERIES/buffy_summers.png": 9290,
	"./TV_SERIES/cersei_lannister.png": 23453,
	"./TV_SERIES/chandler_bing.png": 35973,
	"./TV_SERIES/claire_underwood.png": 70044,
	"./TV_SERIES/clarke_griffin.png": 48617,
	"./TV_SERIES/daenerys_targaryen.png": 46865,
	"./TV_SERIES/dale_cooper.png": 97584,
	"./TV_SERIES/damon_salvatore.png": 63640,
	"./TV_SERIES/dana_scully.png": 66302,
	"./TV_SERIES/dawson_leery.png": 60793,
	"./TV_SERIES/dean_winchester.png": 2634,
	"./TV_SERIES/dexter_morgan.png": 87445,
	"./TV_SERIES/dolores_abernathy.png": 94508,
	"./TV_SERIES/dr_house.png": 61202,
	"./TV_SERIES/dr_who.png": 23897,
	"./TV_SERIES/dustin_henderson.png": 79902,
	"./TV_SERIES/dwight_schrute.png": 15497,
	"./TV_SERIES/eleven.png": 93320,
	"./TV_SERIES/elliot_alderson.png": 75222,
	"./TV_SERIES/eric_cartman.png": 87201,
	"./TV_SERIES/geralt_of_rivia.png": 87932,
	"./TV_SERIES/gus_fring.png": 62739,
	"./TV_SERIES/hannah_baker.png": 58577,
	"./TV_SERIES/homelander.png": 33471,
	"./TV_SERIES/homer_simpson.png": 22866,
	"./TV_SERIES/horatio_caine.png": 40265,
	"./TV_SERIES/jack_shephard.png": 43028,
	"./TV_SERIES/james_mcnulty.png": 79979,
	"./TV_SERIES/jd.png": 90023,
	"./TV_SERIES/jesse_pinkman.png": 28032,
	"./TV_SERIES/jessica_day.png": 61003,
	"./TV_SERIES/jim_halpert.png": 31451,
	"./TV_SERIES/joey_tribbiani.png": 84403,
	"./TV_SERIES/jon_snow.png": 51067,
	"./TV_SERIES/jonas_kahnwald.png": 40975,
	"./TV_SERIES/kenny_mccormick.png": 82254,
	"./TV_SERIES/kim_wexler.png": 87327,
	"./TV_SERIES/kyle_broflovski.png": 534,
	"./TV_SERIES/leonard_hofstadter.png": 42859,
	"./TV_SERIES/leroy_jethro_gibbs.png": 29372,
	"./TV_SERIES/lucas_sinclair.png": 8033,
	"./TV_SERIES/lucifer_morningstar.png": 94082,
	"./TV_SERIES/marge_simpson.png": 40403,
	"./TV_SERIES/meredith_grey.png": 13111,
	"./TV_SERIES/michael_scofield.png": 36187,
	"./TV_SERIES/michael_scott.png": 40309,
	"./TV_SERIES/michael_wheeler.png": 36921,
	"./TV_SERIES/mike_ehrmantraut.png": 25269,
	"./TV_SERIES/monica_geller.png": 67895,
	"./TV_SERIES/morty_smith.png": 71010,
	"./TV_SERIES/negan.png": 18171,
	"./TV_SERIES/otis_milburn.png": 23507,
	"./TV_SERIES/pablo_escobar.png": 94279,
	"./TV_SERIES/pam_beetsy.png": 42754,
	"./TV_SERIES/patrick_jane.png": 6422,
	"./TV_SERIES/penny_teller.png": 40495,
	"./TV_SERIES/peter_griffin.png": 1711,
	"./TV_SERIES/phil_dunphy.png": 40394,
	"./TV_SERIES/phoebe_buffay.png": 66368,
	"./TV_SERIES/piper_chapman.png": 42554,
	"./TV_SERIES/queen_elizabeth.png": 4881,
	"./TV_SERIES/rachel_green.png": 87518,
	"./TV_SERIES/ragnar.png": 78377,
	"./TV_SERIES/rick_grimes.png": 96978,
	"./TV_SERIES/rick_sanchez.png": 38831,
	"./TV_SERIES/ross_geller.png": 4128,
	"./TV_SERIES/sam_winchester.png": 40702,
	"./TV_SERIES/saul_goodman.png": 34179,
	"./TV_SERIES/seong_gi_hun.png": 66024,
	"./TV_SERIES/shaun_murphy.png": 68988,
	"./TV_SERIES/sheldon_cooper.png": 43830,
	"./TV_SERIES/sherlock_holmes.png": 5666,
	"./TV_SERIES/stan_marsh.png": 34278,
	"./TV_SERIES/starlight.png": 15847,
	"./TV_SERIES/stewie_griffin.png": 75577,
	"./TV_SERIES/the_professor.png": 80650,
	"./TV_SERIES/thomas_shelby.png": 21147,
	"./TV_SERIES/tokyo.png": 34605,
	"./TV_SERIES/tony_soprano.png": 2111,
	"./TV_SERIES/tyrion_lannister.png": 7389,
	"./TV_SERIES/walter_white.png": 1798,
	"./TV_SERIES/wednesday.png": 85590,
	"./TV_SERIES/will_byers.png": 99395,
	"./TV_SERIES/william_butcher.png": 65503,
	"./WINTER/acorn.png": 20985,
	"./WINTER/angel.png": 89383,
	"./WINTER/avalanche.png": 7924,
	"./WINTER/bear.png": 2050,
	"./WINTER/bird.png": 73662,
	"./WINTER/blanket.png": 91735,
	"./WINTER/bobsled.png": 77518,
	"./WINTER/boot.png": 19674,
	"./WINTER/boy.png": 8896,
	"./WINTER/breakfast.png": 63275,
	"./WINTER/cable-car-cabin.png": 22053,
	"./WINTER/calendar.png": 51911,
	"./WINTER/candy-cane.png": 17657,
	"./WINTER/car.png": 73849,
	"./WINTER/cheers.png": 89927,
	"./WINTER/chimney.png": 49935,
	"./WINTER/chocolate.png": 89050,
	"./WINTER/christmas-ball.png": 80860,
	"./WINTER/christmas-card.png": 73417,
	"./WINTER/christmas-hat.png": 86628,
	"./WINTER/christmas-present.png": 4291,
	"./WINTER/christmas-sock.png": 85961,
	"./WINTER/christmas-tree.png": 6281,
	"./WINTER/cold.png": 66910,
	"./WINTER/confetti.png": 91886,
	"./WINTER/curling.png": 49680,
	"./WINTER/deer.png": 56450,
	"./WINTER/earmuffs.png": 26908,
	"./WINTER/eskimo.png": 25147,
	"./WINTER/fireplace.png": 16899,
	"./WINTER/firework.png": 10164,
	"./WINTER/fishing.png": 62099,
	"./WINTER/gingerbread.png": 10628,
	"./WINTER/glasses.png": 64030,
	"./WINTER/heater.png": 74560,
	"./WINTER/house.png": 99365,
	"./WINTER/ice-hockey.png": 8150,
	"./WINTER/ice-skate.png": 72310,
	"./WINTER/ice-skating.png": 76659,
	"./WINTER/icicle.png": 76739,
	"./WINTER/igloo.png": 1809,
	"./WINTER/jacket.png": 33661,
	"./WINTER/jingle-bells.png": 2198,
	"./WINTER/matchbox.png": 15727,
	"./WINTER/mistletoe.png": 84426,
	"./WINTER/mitten.png": 24326,
	"./WINTER/mountain.png": 34151,
	"./WINTER/north-pole.png": 27926,
	"./WINTER/owl.png": 76848,
	"./WINTER/penguin.png": 1050,
	"./WINTER/pine-cones.png": 53677,
	"./WINTER/radiator.png": 48245,
	"./WINTER/raincoat.png": 97828,
	"./WINTER/ramp.png": 71019,
	"./WINTER/rocking-horse.png": 7509,
	"./WINTER/santa-claus-dress.png": 48301,
	"./WINTER/santa-claus-sled.png": 57933,
	"./WINTER/santa-claus.png": 49378,
	"./WINTER/scarf.png": 10207,
	"./WINTER/shirt.png": 86316,
	"./WINTER/shooting-star.png": 39042,
	"./WINTER/shovel.png": 32131,
	"./WINTER/ski-jumping.png": 51215,
	"./WINTER/ski-sport.png": 2952,
	"./WINTER/ski.png": 96699,
	"./WINTER/sled.png": 70790,
	"./WINTER/slippers.png": 655,
	"./WINTER/small-sled.png": 64270,
	"./WINTER/snow-angel.png": 42938,
	"./WINTER/snow-ball.png": 7475,
	"./WINTER/snow-globe.png": 46801,
	"./WINTER/snow.png": 14303,
	"./WINTER/snowboard-sport.png": 34543,
	"./WINTER/snowboard.png": 86433,
	"./WINTER/snowman.png": 16855,
	"./WINTER/snowmobile.png": 92997,
	"./WINTER/snowplow.png": 72922,
	"./WINTER/snowshoes.png": 87795,
	"./WINTER/soldier.png": 40581,
	"./WINTER/soup.png": 6988,
	"./WINTER/star.png": 24027,
	"./WINTER/sweater.png": 88311,
	"./WINTER/tea-cup.png": 99290,
	"./WINTER/thermo.png": 91954,
	"./WINTER/thermometer.png": 7446,
	"./WINTER/tire.png": 93408,
	"./WINTER/window.png": 64389,
	"./WINTER/winter-hat.png": 6392,
	"./WINTER/wolf.png": 20220,
	"./WINTER/yeti.png": 78907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63728;